export default {
  "2" : {
    "scenarioValuesAllRegions": [
      {
        "regionId": "1",
        "year": 2012,
        "scenarioValue": 0.814854406882111
      },
      {
        "regionId": "1",
        "year": 2020,
        "scenarioValue": 0.731041631349338
      },
      {
        "regionId": "1",
        "year": 2030,
        "scenarioValue": 0.795637036667914
      },
      {
        "regionId": "1",
        "year": 2040,
        "scenarioValue": 0.845166373797576
      },
      {
        "regionId": "1",
        "year": 2050,
        "scenarioValue": 0.918760409909364
      },
      {
        "regionId": "1",
        "year": 2060,
        "scenarioValue": 0.967192724156615
      },
      {
        "regionId": "1",
        "year": 2070,
        "scenarioValue": 0.999806085789787
      },
      {
        "regionId": "1",
        "year": 2080,
        "scenarioValue": 1.02058640679191
      },
      {
        "regionId": "1",
        "year": 2090,
        "scenarioValue": 1.04634557354133
      },
      {
        "regionId": "1",
        "year": 2100,
        "scenarioValue": 1.06404927956024
      },
      {
        "regionId": "2",
        "year": 2012,
        "scenarioValue": 4.95660455928561
      },
      {
        "regionId": "2",
        "year": 2020,
        "scenarioValue": 5.78561296173125
      },
      {
        "regionId": "2",
        "year": 2030,
        "scenarioValue": 6.8846654069932
      },
      {
        "regionId": "2",
        "year": 2040,
        "scenarioValue": 7.13923777747032
      },
      {
        "regionId": "2",
        "year": 2050,
        "scenarioValue": 7.63198842718885
      },
      {
        "regionId": "2",
        "year": 2060,
        "scenarioValue": 7.71543553693612
      },
      {
        "regionId": "2",
        "year": 2070,
        "scenarioValue": 7.68219875899617
      },
      {
        "regionId": "2",
        "year": 2080,
        "scenarioValue": 7.55869142401627
      },
      {
        "regionId": "2",
        "year": 2090,
        "scenarioValue": 7.55449403908331
      },
      {
        "regionId": "2",
        "year": 2100,
        "scenarioValue": 7.47945985858714
      },
      {
        "regionId": "3",
        "year": 2012,
        "scenarioValue": 1.81803325797726
      },
      {
        "regionId": "3",
        "year": 2020,
        "scenarioValue": 1.80971556601252
      },
      {
        "regionId": "3",
        "year": 2030,
        "scenarioValue": 2.50594665228966
      },
      {
        "regionId": "3",
        "year": 2040,
        "scenarioValue": 3.03727785341089
      },
      {
        "regionId": "3",
        "year": 2050,
        "scenarioValue": 3.33561515313382
      },
      {
        "regionId": "3",
        "year": 2060,
        "scenarioValue": 3.49644946357818
      },
      {
        "regionId": "3",
        "year": 2070,
        "scenarioValue": 3.66123591010184
      },
      {
        "regionId": "3",
        "year": 2080,
        "scenarioValue": 3.83576457023251
      },
      {
        "regionId": "3",
        "year": 2090,
        "scenarioValue": 3.96238488162598
      },
      {
        "regionId": "3",
        "year": 2100,
        "scenarioValue": 4.07131109737255
      },
      {
        "regionId": "4",
        "year": 2012,
        "scenarioValue": 4.65940159251119
      },
      {
        "regionId": "4",
        "year": 2020,
        "scenarioValue": 3.55197149146811
      },
      {
        "regionId": "4",
        "year": 2030,
        "scenarioValue": 4.07876591332026
      },
      {
        "regionId": "4",
        "year": 2040,
        "scenarioValue": 4.47736463823574
      },
      {
        "regionId": "4",
        "year": 2050,
        "scenarioValue": 4.81242952815895
      },
      {
        "regionId": "4",
        "year": 2060,
        "scenarioValue": 5.61068106100955
      },
      {
        "regionId": "4",
        "year": 2070,
        "scenarioValue": 6.10471587672282
      },
      {
        "regionId": "4",
        "year": 2080,
        "scenarioValue": 6.1719080681865
      },
      {
        "regionId": "4",
        "year": 2090,
        "scenarioValue": 6.2593301510766
      },
      {
        "regionId": "4",
        "year": 2100,
        "scenarioValue": 6.30169399678598
      },
      {
        "regionId": "5",
        "year": 2012,
        "scenarioValue": 1.93097449860794
      },
      {
        "regionId": "5",
        "year": 2020,
        "scenarioValue": 2.1289968731591
      },
      {
        "regionId": "5",
        "year": 2030,
        "scenarioValue": 2.51166318476673
      },
      {
        "regionId": "5",
        "year": 2040,
        "scenarioValue": 2.89362325098176
      },
      {
        "regionId": "5",
        "year": 2050,
        "scenarioValue": 3.24647219938486
      },
      {
        "regionId": "5",
        "year": 2060,
        "scenarioValue": 3.67246929194142
      },
      {
        "regionId": "5",
        "year": 2070,
        "scenarioValue": 4.00594966748274
      },
      {
        "regionId": "5",
        "year": 2080,
        "scenarioValue": 4.26038247533637
      },
      {
        "regionId": "5",
        "year": 2090,
        "scenarioValue": 4.52715649423845
      },
      {
        "regionId": "5",
        "year": 2100,
        "scenarioValue": 4.74360015277323
      },
      {
        "regionId": "6",
        "year": 2012,
        "scenarioValue": 1.58736684980022
      },
      {
        "regionId": "6",
        "year": 2020,
        "scenarioValue": 1.52053546379219
      },
      {
        "regionId": "6",
        "year": 2030,
        "scenarioValue": 1.72390873332738
      },
      {
        "regionId": "6",
        "year": 2040,
        "scenarioValue": 1.88307533550285
      },
      {
        "regionId": "6",
        "year": 2050,
        "scenarioValue": 2.04888194014395
      },
      {
        "regionId": "6",
        "year": 2060,
        "scenarioValue": 2.14788006524976
      },
      {
        "regionId": "6",
        "year": 2070,
        "scenarioValue": 2.2000846222953
      },
      {
        "regionId": "6",
        "year": 2080,
        "scenarioValue": 2.23937784264405
      },
      {
        "regionId": "6",
        "year": 2090,
        "scenarioValue": 2.27923775289292
      },
      {
        "regionId": "6",
        "year": 2100,
        "scenarioValue": 2.29831650902807
      },
      {
        "regionId": "7",
        "year": 2012,
        "scenarioValue": 2.67115415884957
      },
      {
        "regionId": "7",
        "year": 2020,
        "scenarioValue": 2.89198721589716
      },
      {
        "regionId": "7",
        "year": 2030,
        "scenarioValue": 2.85218984665883
      },
      {
        "regionId": "7",
        "year": 2040,
        "scenarioValue": 2.83352417859996
      },
      {
        "regionId": "7",
        "year": 2050,
        "scenarioValue": 2.99955623111221
      },
      {
        "regionId": "7",
        "year": 2060,
        "scenarioValue": 3.60736943624238
      },
      {
        "regionId": "7",
        "year": 2070,
        "scenarioValue": 4.03505787348684
      },
      {
        "regionId": "7",
        "year": 2080,
        "scenarioValue": 4.19659087603334
      },
      {
        "regionId": "7",
        "year": 2090,
        "scenarioValue": 4.3296304597474
      },
      {
        "regionId": "7",
        "year": 2100,
        "scenarioValue": 4.42705903327203
      },
      {
        "regionId": "8",
        "year": 2012,
        "scenarioValue": 0.666442526068227
      },
      {
        "regionId": "8",
        "year": 2020,
        "scenarioValue": 0.707843147764104
      },
      {
        "regionId": "8",
        "year": 2030,
        "scenarioValue": 0.975233545677213
      },
      {
        "regionId": "8",
        "year": 2040,
        "scenarioValue": 1.14435030454631
      },
      {
        "regionId": "8",
        "year": 2050,
        "scenarioValue": 1.20605769982449
      },
      {
        "regionId": "8",
        "year": 2060,
        "scenarioValue": 1.28773711460669
      },
      {
        "regionId": "8",
        "year": 2070,
        "scenarioValue": 1.3648826770454
      },
      {
        "regionId": "8",
        "year": 2080,
        "scenarioValue": 1.43335107053734
      },
      {
        "regionId": "8",
        "year": 2090,
        "scenarioValue": 1.49928329673279
      },
      {
        "regionId": "8",
        "year": 2100,
        "scenarioValue": 1.55273271098018
      },
      {
        "regionId": "9",
        "year": 2012,
        "scenarioValue": 2.85943716313034
      },
      {
        "regionId": "9",
        "year": 2020,
        "scenarioValue": 3.31678885084484
      },
      {
        "regionId": "9",
        "year": 2030,
        "scenarioValue": 3.87402658891697
      },
      {
        "regionId": "9",
        "year": 2040,
        "scenarioValue": 4.09058862899895
      },
      {
        "regionId": "9",
        "year": 2050,
        "scenarioValue": 4.41065907448826
      },
      {
        "regionId": "9",
        "year": 2060,
        "scenarioValue": 4.72842647531498
      },
      {
        "regionId": "9",
        "year": 2070,
        "scenarioValue": 5.0293964615767
      },
      {
        "regionId": "9",
        "year": 2080,
        "scenarioValue": 5.28499345358588
      },
      {
        "regionId": "9",
        "year": 2090,
        "scenarioValue": 5.55720509598252
      },
      {
        "regionId": "9",
        "year": 2100,
        "scenarioValue": 5.82493897853683
      },
      {
        "regionId": "10",
        "year": 2012,
        "scenarioValue": 1.78970943923085
      },
      {
        "regionId": "10",
        "year": 2020,
        "scenarioValue": 1.30630850375723
      },
      {
        "regionId": "10",
        "year": 2030,
        "scenarioValue": 1.35374297216694
      },
      {
        "regionId": "10",
        "year": 2040,
        "scenarioValue": 1.35067880502543
      },
      {
        "regionId": "10",
        "year": 2050,
        "scenarioValue": 1.43332402279785
      },
      {
        "regionId": "10",
        "year": 2060,
        "scenarioValue": 1.49953860646407
      },
      {
        "regionId": "10",
        "year": 2070,
        "scenarioValue": 1.5504728958208
      },
      {
        "regionId": "10",
        "year": 2080,
        "scenarioValue": 1.58919709886007
      },
      {
        "regionId": "10",
        "year": 2090,
        "scenarioValue": 1.62390820257326
      },
      {
        "regionId": "10",
        "year": 2100,
        "scenarioValue": 1.64157140428058
      },
      {
        "regionId": "11",
        "year": 2012,
        "scenarioValue": 1.64617000028819
      },
      {
        "regionId": "11",
        "year": 2020,
        "scenarioValue": 1.11271523805345
      },
      {
        "regionId": "11",
        "year": 2030,
        "scenarioValue": 1.27427787915947
      },
      {
        "regionId": "11",
        "year": 2040,
        "scenarioValue": 1.36871991332528
      },
      {
        "regionId": "11",
        "year": 2050,
        "scenarioValue": 1.44884105344104
      },
      {
        "regionId": "11",
        "year": 2060,
        "scenarioValue": 1.5143261625076
      },
      {
        "regionId": "11",
        "year": 2070,
        "scenarioValue": 1.55198580181967
      },
      {
        "regionId": "11",
        "year": 2080,
        "scenarioValue": 1.58670493140007
      },
      {
        "regionId": "11",
        "year": 2090,
        "scenarioValue": 1.61721603401056
      },
      {
        "regionId": "11",
        "year": 2100,
        "scenarioValue": 1.62711079829037
      },
      {
        "regionId": "12",
        "year": 2012,
        "scenarioValue": 0.781771033086958
      },
      {
        "regionId": "12",
        "year": 2020,
        "scenarioValue": 0.826226338610505
      },
      {
        "regionId": "12",
        "year": 2030,
        "scenarioValue": 0.989054736610901
      },
      {
        "regionId": "12",
        "year": 2040,
        "scenarioValue": 1.10324537109974
      },
      {
        "regionId": "12",
        "year": 2050,
        "scenarioValue": 1.16981093009215
      },
      {
        "regionId": "12",
        "year": 2060,
        "scenarioValue": 1.27136694978427
      },
      {
        "regionId": "12",
        "year": 2070,
        "scenarioValue": 1.35067066776965
      },
      {
        "regionId": "12",
        "year": 2080,
        "scenarioValue": 1.42003584539202
      },
      {
        "regionId": "12",
        "year": 2090,
        "scenarioValue": 1.49206320299304
      },
      {
        "regionId": "12",
        "year": 2100,
        "scenarioValue": 1.54703847014183
      },
      {
        "regionId": "13",
        "year": 2012,
        "scenarioValue": 1.73859530875977
      },
      {
        "regionId": "13",
        "year": 2020,
        "scenarioValue": 1.91502020219651
      },
      {
        "regionId": "13",
        "year": 2030,
        "scenarioValue": 2.57912518096091
      },
      {
        "regionId": "13",
        "year": 2040,
        "scenarioValue": 2.9678575972979
      },
      {
        "regionId": "13",
        "year": 2050,
        "scenarioValue": 3.30291099868816
      },
      {
        "regionId": "13",
        "year": 2060,
        "scenarioValue": 3.46839470850968
      },
      {
        "regionId": "13",
        "year": 2070,
        "scenarioValue": 3.58138760744228
      },
      {
        "regionId": "13",
        "year": 2080,
        "scenarioValue": 3.59798349832366
      },
      {
        "regionId": "13",
        "year": 2090,
        "scenarioValue": 3.7347593836729
      },
      {
        "regionId": "13",
        "year": 2100,
        "scenarioValue": 3.83838443440108
      },
      {
        "regionId": "14",
        "year": 2012,
        "scenarioValue": 3.23537910091242
      },
      {
        "regionId": "14",
        "year": 2020,
        "scenarioValue": 2.70843154521764
      },
      {
        "regionId": "14",
        "year": 2030,
        "scenarioValue": 2.98069654810514
      },
      {
        "regionId": "14",
        "year": 2040,
        "scenarioValue": 3.24871365934991
      },
      {
        "regionId": "14",
        "year": 2050,
        "scenarioValue": 3.44030141616694
      },
      {
        "regionId": "14",
        "year": 2060,
        "scenarioValue": 3.61735621308684
      },
      {
        "regionId": "14",
        "year": 2070,
        "scenarioValue": 3.80832758824013
      },
      {
        "regionId": "14",
        "year": 2080,
        "scenarioValue": 3.99191632318197
      },
      {
        "regionId": "14",
        "year": 2090,
        "scenarioValue": 4.0867218380439
      },
      {
        "regionId": "14",
        "year": 2100,
        "scenarioValue": 4.14142754253523
      },
      {
        "regionId": "15",
        "year": 2012,
        "scenarioValue": 3.23537910091242
      },
      {
        "regionId": "15",
        "year": 2020,
        "scenarioValue": 3.70970507018786
      },
      {
        "regionId": "15",
        "year": 2030,
        "scenarioValue": 3.80194645259331
      },
      {
        "regionId": "15",
        "year": 2040,
        "scenarioValue": 3.99616364413474
      },
      {
        "regionId": "15",
        "year": 2050,
        "scenarioValue": 4.33949735435167
      },
      {
        "regionId": "15",
        "year": 2060,
        "scenarioValue": 4.73884546204607
      },
      {
        "regionId": "15",
        "year": 2070,
        "scenarioValue": 5.23595488959088
      },
      {
        "regionId": "15",
        "year": 2080,
        "scenarioValue": 5.88618094087485
      },
      {
        "regionId": "15",
        "year": 2090,
        "scenarioValue": 6.25464446592769
      },
      {
        "regionId": "15",
        "year": 2100,
        "scenarioValue": 6.58863452781882
      },
      {
        "regionId": "16",
        "year": 2012,
        "scenarioValue": 4.67648986241038
      },
      {
        "regionId": "16",
        "year": 2020,
        "scenarioValue": 5.00510360581739
      },
      {
        "regionId": "16",
        "year": 2030,
        "scenarioValue": 4.90084834086381
      },
      {
        "regionId": "16",
        "year": 2040,
        "scenarioValue": 5.09107506540148
      },
      {
        "regionId": "16",
        "year": 2050,
        "scenarioValue": 5.27822343076394
      },
      {
        "regionId": "16",
        "year": 2060,
        "scenarioValue": 5.55730110487273
      },
      {
        "regionId": "16",
        "year": 2070,
        "scenarioValue": 5.73004193629964
      },
      {
        "regionId": "16",
        "year": 2080,
        "scenarioValue": 5.80771394459786
      },
      {
        "regionId": "16",
        "year": 2090,
        "scenarioValue": 5.94031221956195
      },
      {
        "regionId": "16",
        "year": 2100,
        "scenarioValue": 6.00973339763824
      }
    ],
    "factor": {
      "id": "2",
      "unit": "Number of earths",
      "unitShort": "earths",
      "title": "Required Earths"
    }
  },
  "3" : {
    "scenarioValuesAllRegions": [
      {
        "regionId": "1",
        "year": 2000,
        "scenarioValue": 805.514439
      },
      {
        "regionId": "1",
        "year": 2010,
        "scenarioValue": 1032.023133
      },
      {
        "regionId": "1",
        "year": 2020,
        "scenarioValue": 1213.916
      },
      {
        "regionId": "1",
        "year": 2030,
        "scenarioValue": 1459.082
      },
      {
        "regionId": "1",
        "year": 2040,
        "scenarioValue": 1702.005
      },
      {
        "regionId": "1",
        "year": 2050,
        "scenarioValue": 1928.584
      },
      {
        "regionId": "1",
        "year": 2060,
        "scenarioValue": 2120.519
      },
      {
        "regionId": "1",
        "year": 2070,
        "scenarioValue": 2277.782
      },
      {
        "regionId": "1",
        "year": 2080,
        "scenarioValue": 2398.098
      },
      {
        "regionId": "1",
        "year": 2090,
        "scenarioValue": 2480.255
      },
      {
        "regionId": "1",
        "year": 2100,
        "scenarioValue": 2527.785
      },
      {
        "regionId": "2",
        "year": 2000,
        "scenarioValue": 23.0107
      },
      {
        "regionId": "2",
        "year": 2010,
        "scenarioValue": 26.38245
      },
      {
        "regionId": "2",
        "year": 2020,
        "scenarioValue": 30.839
      },
      {
        "regionId": "2",
        "year": 2030,
        "scenarioValue": 34.842
      },
      {
        "regionId": "2",
        "year": 2040,
        "scenarioValue": 38.491
      },
      {
        "regionId": "2",
        "year": 2050,
        "scenarioValue": 41.973
      },
      {
        "regionId": "2",
        "year": 2060,
        "scenarioValue": 45.115
      },
      {
        "regionId": "2",
        "year": 2070,
        "scenarioValue": 47.493
      },
      {
        "regionId": "2",
        "year": 2080,
        "scenarioValue": 49.028
      },
      {
        "regionId": "2",
        "year": 2090,
        "scenarioValue": 49.598
      },
      {
        "regionId": "2",
        "year": 2100,
        "scenarioValue": 49.086
      },
      {
        "regionId": "3",
        "year": 2000,
        "scenarioValue": 64.476843
      },
      {
        "regionId": "3",
        "year": 2010,
        "scenarioValue": 71.317704
      },
      {
        "regionId": "3",
        "year": 2020,
        "scenarioValue": 76.491
      },
      {
        "regionId": "3",
        "year": 2030,
        "scenarioValue": 80.34
      },
      {
        "regionId": "3",
        "year": 2040,
        "scenarioValue": 82.55
      },
      {
        "regionId": "3",
        "year": 2050,
        "scenarioValue": 83.25
      },
      {
        "regionId": "3",
        "year": 2060,
        "scenarioValue": 82.254
      },
      {
        "regionId": "3",
        "year": 2070,
        "scenarioValue": 80.353
      },
      {
        "regionId": "3",
        "year": 2080,
        "scenarioValue": 77.673
      },
      {
        "regionId": "3",
        "year": 2090,
        "scenarioValue": 74.638
      },
      {
        "regionId": "3",
        "year": 2100,
        "scenarioValue": 71.699
      },
      {
        "regionId": "4",
        "year": 2000,
        "scenarioValue": 30.7697
      },
      {
        "regionId": "4",
        "year": 2010,
        "scenarioValue": 34.005274
      },
      {
        "regionId": "4",
        "year": 2020,
        "scenarioValue": 37.764
      },
      {
        "regionId": "4",
        "year": 2030,
        "scenarioValue": 41.384
      },
      {
        "regionId": "4",
        "year": 2040,
        "scenarioValue": 44.54
      },
      {
        "regionId": "4",
        "year": 2050,
        "scenarioValue": 47.585
      },
      {
        "regionId": "4",
        "year": 2060,
        "scenarioValue": 50.465
      },
      {
        "regionId": "4",
        "year": 2070,
        "scenarioValue": 52.762
      },
      {
        "regionId": "4",
        "year": 2080,
        "scenarioValue": 54.322
      },
      {
        "regionId": "4",
        "year": 2090,
        "scenarioValue": 54.945
      },
      {
        "regionId": "4",
        "year": 2100,
        "scenarioValue": 54.424
      },
      {
        "regionId": "5",
        "year": 2000,
        "scenarioValue": 1269.741907
      },
      {
        "regionId": "5",
        "year": 2010,
        "scenarioValue": 1345.263826
      },
      {
        "regionId": "5",
        "year": 2020,
        "scenarioValue": 1386.876
      },
      {
        "regionId": "5",
        "year": 2030,
        "scenarioValue": 1388.904
      },
      {
        "regionId": "5",
        "year": 2040,
        "scenarioValue": 1348.405
      },
      {
        "regionId": "5",
        "year": 2050,
        "scenarioValue": 1272.405
      },
      {
        "regionId": "5",
        "year": 2060,
        "scenarioValue": 1173.371
      },
      {
        "regionId": "5",
        "year": 2070,
        "scenarioValue": 1066.801
      },
      {
        "regionId": "5",
        "year": 2080,
        "scenarioValue": 961.33
      },
      {
        "regionId": "5",
        "year": 2090,
        "scenarioValue": 861.436
      },
      {
        "regionId": "5",
        "year": 2100,
        "scenarioValue": 775.771
      },
      {
        "regionId": "6",
        "year": 2000,
        "scenarioValue": 422.705601
      },
      {
        "regionId": "6",
        "year": 2010,
        "scenarioValue": 479.655398
      },
      {
        "regionId": "6",
        "year": 2020,
        "scenarioValue": 509.257
      },
      {
        "regionId": "6",
        "year": 2030,
        "scenarioValue": 546.473
      },
      {
        "regionId": "6",
        "year": 2040,
        "scenarioValue": 572.101
      },
      {
        "regionId": "6",
        "year": 2050,
        "scenarioValue": 585.733
      },
      {
        "regionId": "6",
        "year": 2060,
        "scenarioValue": 587.171
      },
      {
        "regionId": "6",
        "year": 2070,
        "scenarioValue": 579.566
      },
      {
        "regionId": "6",
        "year": 2080,
        "scenarioValue": 564.678
      },
      {
        "regionId": "6",
        "year": 2090,
        "scenarioValue": 544.937
      },
      {
        "regionId": "6",
        "year": 2100,
        "scenarioValue": 523.03
      },
      {
        "regionId": "7",
        "year": 2000,
        "scenarioValue": 500.323335
      },
      {
        "regionId": "7",
        "year": 2010,
        "scenarioValue": 518.018845
      },
      {
        "regionId": "7",
        "year": 2020,
        "scenarioValue": 533.209
      },
      {
        "regionId": "7",
        "year": 2030,
        "scenarioValue": 544.579
      },
      {
        "regionId": "7",
        "year": 2040,
        "scenarioValue": 552.703
      },
      {
        "regionId": "7",
        "year": 2050,
        "scenarioValue": 557.837
      },
      {
        "regionId": "7",
        "year": 2060,
        "scenarioValue": 558.804
      },
      {
        "regionId": "7",
        "year": 2070,
        "scenarioValue": 554.926
      },
      {
        "regionId": "7",
        "year": 2080,
        "scenarioValue": 548.306
      },
      {
        "regionId": "7",
        "year": 2090,
        "scenarioValue": 539.125
      },
      {
        "regionId": "7",
        "year": 2100,
        "scenarioValue": 525.941
      },
      {
        "regionId": "8",
        "year": 2000,
        "scenarioValue": 1053.481072
      },
      {
        "regionId": "8",
        "year": 2010,
        "scenarioValue": 1230.984504
      },
      {
        "regionId": "8",
        "year": 2020,
        "scenarioValue": 1388.089
      },
      {
        "regionId": "8",
        "year": 2030,
        "scenarioValue": 1528.595
      },
      {
        "regionId": "8",
        "year": 2040,
        "scenarioValue": 1645.885
      },
      {
        "regionId": "8",
        "year": 2050,
        "scenarioValue": 1733.795
      },
      {
        "regionId": "8",
        "year": 2060,
        "scenarioValue": 1779.295
      },
      {
        "regionId": "8",
        "year": 2070,
        "scenarioValue": 1781.252
      },
      {
        "regionId": "8",
        "year": 2080,
        "scenarioValue": 1747.797
      },
      {
        "regionId": "8",
        "year": 2090,
        "scenarioValue": 1684.434
      },
      {
        "regionId": "8",
        "year": 2100,
        "scenarioValue": 1602.936
      },
      {
        "regionId": "9",
        "year": 2000,
        "scenarioValue": 126.843
      },
      {
        "regionId": "9",
        "year": 2010,
        "scenarioValue": 128.07
      },
      {
        "regionId": "9",
        "year": 2020,
        "scenarioValue": 124.813
      },
      {
        "regionId": "9",
        "year": 2030,
        "scenarioValue": 120.41
      },
      {
        "regionId": "9",
        "year": 2040,
        "scenarioValue": 114.754
      },
      {
        "regionId": "9",
        "year": 2050,
        "scenarioValue": 108.609
      },
      {
        "regionId": "9",
        "year": 2060,
        "scenarioValue": 102.415
      },
      {
        "regionId": "9",
        "year": 2070,
        "scenarioValue": 95.619
      },
      {
        "regionId": "9",
        "year": 2080,
        "scenarioValue": 88.69
      },
      {
        "regionId": "9",
        "year": 2090,
        "scenarioValue": 81.686
      },
      {
        "regionId": "9",
        "year": 2100,
        "scenarioValue": 74.941
      },
      {
        "regionId": "10",
        "year": 2000,
        "scenarioValue": 230.977677
      },
      {
        "regionId": "10",
        "year": 2010,
        "scenarioValue": 285.673339
      },
      {
        "regionId": "10",
        "year": 2020,
        "scenarioValue": 301.465
      },
      {
        "regionId": "10",
        "year": 2030,
        "scenarioValue": 344.371
      },
      {
        "regionId": "10",
        "year": 2040,
        "scenarioValue": 383.005
      },
      {
        "regionId": "10",
        "year": 2050,
        "scenarioValue": 415.033
      },
      {
        "regionId": "10",
        "year": 2060,
        "scenarioValue": 437.621
      },
      {
        "regionId": "10",
        "year": 2070,
        "scenarioValue": 451.425
      },
      {
        "regionId": "10",
        "year": 2080,
        "scenarioValue": 457.121
      },
      {
        "regionId": "10",
        "year": 2090,
        "scenarioValue": 456.546
      },
      {
        "regionId": "10",
        "year": 2100,
        "scenarioValue": 452.085
      },
      {
        "regionId": "11",
        "year": 2000,
        "scenarioValue": 102.80859
      },
      {
        "regionId": "11",
        "year": 2010,
        "scenarioValue": 118.617542
      },
      {
        "regionId": "11",
        "year": 2020,
        "scenarioValue": 126.183
      },
      {
        "regionId": "11",
        "year": 2030,
        "scenarioValue": 136.747
      },
      {
        "regionId": "11",
        "year": 2040,
        "scenarioValue": 144.298
      },
      {
        "regionId": "11",
        "year": 2050,
        "scenarioValue": 148.719
      },
      {
        "regionId": "11",
        "year": 2060,
        "scenarioValue": 150.033
      },
      {
        "regionId": "11",
        "year": 2070,
        "scenarioValue": 149.685
      },
      {
        "regionId": "11",
        "year": 2080,
        "scenarioValue": 148.421
      },
      {
        "regionId": "11",
        "year": 2090,
        "scenarioValue": 145.998
      },
      {
        "regionId": "11",
        "year": 2100,
        "scenarioValue": 143.066
      },
      {
        "regionId": "12",
        "year": 2000,
        "scenarioValue": 875.941674
      },
      {
        "regionId": "12",
        "year": 2010,
        "scenarioValue": 1016.395903
      },
      {
        "regionId": "12",
        "year": 2020,
        "scenarioValue": 1035.032
      },
      {
        "regionId": "12",
        "year": 2030,
        "scenarioValue": 1135.862
      },
      {
        "regionId": "12",
        "year": 2040,
        "scenarioValue": 1210.999
      },
      {
        "regionId": "12",
        "year": 2050,
        "scenarioValue": 1258.811
      },
      {
        "regionId": "12",
        "year": 2060,
        "scenarioValue": 1277.662
      },
      {
        "regionId": "12",
        "year": 2070,
        "scenarioValue": 1272.334
      },
      {
        "regionId": "12",
        "year": 2080,
        "scenarioValue": 1249.407
      },
      {
        "regionId": "12",
        "year": 2090,
        "scenarioValue": 1213.873
      },
      {
        "regionId": "12",
        "year": 2100,
        "scenarioValue": 1170.918
      },
      {
        "regionId": "13",
        "year": 2000,
        "scenarioValue": 79.835692
      },
      {
        "regionId": "13",
        "year": 2010,
        "scenarioValue": 75.644331
      },
      {
        "regionId": "13",
        "year": 2020,
        "scenarioValue": 70.983
      },
      {
        "regionId": "13",
        "year": 2030,
        "scenarioValue": 68.418
      },
      {
        "regionId": "13",
        "year": 2040,
        "scenarioValue": 66.365
      },
      {
        "regionId": "13",
        "year": 2050,
        "scenarioValue": 64.55
      },
      {
        "regionId": "13",
        "year": 2060,
        "scenarioValue": 62.811
      },
      {
        "regionId": "13",
        "year": 2070,
        "scenarioValue": 60.635
      },
      {
        "regionId": "13",
        "year": 2080,
        "scenarioValue": 57.97
      },
      {
        "regionId": "13",
        "year": 2090,
        "scenarioValue": 55.078
      },
      {
        "regionId": "13",
        "year": 2100,
        "scenarioValue": 52.076
      },
      {
        "regionId": "14",
        "year": 2000,
        "scenarioValue": 146.596557
      },
      {
        "regionId": "14",
        "year": 2010,
        "scenarioValue": 142.849449
      },
      {
        "regionId": "14",
        "year": 2020,
        "scenarioValue": 141.969
      },
      {
        "regionId": "14",
        "year": 2030,
        "scenarioValue": 139.632
      },
      {
        "regionId": "14",
        "year": 2040,
        "scenarioValue": 137.792
      },
      {
        "regionId": "14",
        "year": 2050,
        "scenarioValue": 136.715
      },
      {
        "regionId": "14",
        "year": 2060,
        "scenarioValue": 135.424
      },
      {
        "regionId": "14",
        "year": 2070,
        "scenarioValue": 133.427
      },
      {
        "regionId": "14",
        "year": 2080,
        "scenarioValue": 130.636
      },
      {
        "regionId": "14",
        "year": 2090,
        "scenarioValue": 126.968
      },
      {
        "regionId": "14",
        "year": 2100,
        "scenarioValue": 122.622
      },
      {
        "regionId": "15",
        "year": 2000,
        "scenarioValue": 47.008111
      },
      {
        "regionId": "15",
        "year": 2010,
        "scenarioValue": 49.410366
      },
      {
        "regionId": "15",
        "year": 2020,
        "scenarioValue": 49.378
      },
      {
        "regionId": "15",
        "year": 2030,
        "scenarioValue": 49.661
      },
      {
        "regionId": "15",
        "year": 2040,
        "scenarioValue": 48.63
      },
      {
        "regionId": "15",
        "year": 2050,
        "scenarioValue": 46.183
      },
      {
        "regionId": "15",
        "year": 2060,
        "scenarioValue": 42.906
      },
      {
        "regionId": "15",
        "year": 2070,
        "scenarioValue": 39.392
      },
      {
        "regionId": "15",
        "year": 2080,
        "scenarioValue": 35.975
      },
      {
        "regionId": "15",
        "year": 2090,
        "scenarioValue": 32.855
      },
      {
        "regionId": "15",
        "year": 2100,
        "scenarioValue": 30.044
      },
      {
        "regionId": "16",
        "year": 2000,
        "scenarioValue": 282.162411
      },
      {
        "regionId": "16",
        "year": 2010,
        "scenarioValue": 309.346863
      },
      {
        "regionId": "16",
        "year": 2020,
        "scenarioValue": 335.751
      },
      {
        "regionId": "16",
        "year": 2030,
        "scenarioValue": 361.029
      },
      {
        "regionId": "16",
        "year": 2040,
        "scenarioValue": 383.233
      },
      {
        "regionId": "16",
        "year": 2050,
        "scenarioValue": 402.305
      },
      {
        "regionId": "16",
        "year": 2060,
        "scenarioValue": 420.93
      },
      {
        "regionId": "16",
        "year": 2070,
        "scenarioValue": 437.638
      },
      {
        "regionId": "16",
        "year": 2080,
        "scenarioValue": 449.545
      },
      {
        "regionId": "16",
        "year": 2090,
        "scenarioValue": 456.212
      },
      {
        "regionId": "16",
        "year": 2100,
        "scenarioValue": 458.56
      }
    ],
    "factor": {
      "id": "3",
      "unit": "Million persons",
      "unitShort": "mill",
      "title": "Population"
    }    
  },
  "4" : {
    "scenarioValuesAllRegions": [
      {
        "regionId": "1",
        "year": 2000,
        "scenarioValue": 1450.85309139547
      },
      {
        "regionId": "1",
        "year": 2010,
        "scenarioValue": 1895.00562473629
      },
      {
        "regionId": "1",
        "year": 2020,
        "scenarioValue": 1432.57323121071
      },
      {
        "regionId": "1",
        "year": 2030,
        "scenarioValue": 1869.99501788707
      },
      {
        "regionId": "1",
        "year": 2040,
        "scenarioValue": 2477.65123612829
      },
      {
        "regionId": "1",
        "year": 2050,
        "scenarioValue": 3232.96505839361
      },
      {
        "regionId": "1",
        "year": 2060,
        "scenarioValue": 4122.13756849365
      },
      {
        "regionId": "1",
        "year": 2070,
        "scenarioValue": 5123.05977670665
      },
      {
        "regionId": "1",
        "year": 2080,
        "scenarioValue": 6243.28386809973
      },
      {
        "regionId": "1",
        "year": 2090,
        "scenarioValue": 7510.48241657838
      },
      {
        "regionId": "1",
        "year": 2100,
        "scenarioValue": 8918.09444631496
      },
      {
        "regionId": "2",
        "year": 2000,
        "scenarioValue": 41733.1929525014
      },
      {
        "regionId": "2",
        "year": 2010,
        "scenarioValue": 48851.9841310991
      },
      {
        "regionId": "2",
        "year": 2020,
        "scenarioValue": 70266.1876497917
      },
      {
        "regionId": "2",
        "year": 2030,
        "scenarioValue": 87067.795325589
      },
      {
        "regionId": "2",
        "year": 2040,
        "scenarioValue": 100882.40217669
      },
      {
        "regionId": "2",
        "year": 2050,
        "scenarioValue": 111898.697436507
      },
      {
        "regionId": "2",
        "year": 2060,
        "scenarioValue": 121700.892687424
      },
      {
        "regionId": "2",
        "year": 2070,
        "scenarioValue": 131720.36849391
      },
      {
        "regionId": "2",
        "year": 2080,
        "scenarioValue": 141515.078894071
      },
      {
        "regionId": "2",
        "year": 2090,
        "scenarioValue": 151331.285601999
      },
      {
        "regionId": "2",
        "year": 2100,
        "scenarioValue": 161669.58510636
      },
      {
        "regionId": "3",
        "year": 2000,
        "scenarioValue": 1933.55656363783
      },
      {
        "regionId": "3",
        "year": 2010,
        "scenarioValue": 4046.10838374483
      },
      {
        "regionId": "3",
        "year": 2020,
        "scenarioValue": 6909.12633345003
      },
      {
        "regionId": "3",
        "year": 2030,
        "scenarioValue": 10854.2799771021
      },
      {
        "regionId": "3",
        "year": 2040,
        "scenarioValue": 12982.9901980301
      },
      {
        "regionId": "3",
        "year": 2050,
        "scenarioValue": 14324.9551570762
      },
      {
        "regionId": "3",
        "year": 2060,
        "scenarioValue": 15839.2578459555
      },
      {
        "regionId": "3",
        "year": 2070,
        "scenarioValue": 17657.4557634424
      },
      {
        "regionId": "3",
        "year": 2080,
        "scenarioValue": 19757.4036665257
      },
      {
        "regionId": "3",
        "year": 2090,
        "scenarioValue": 22179.1186232971
      },
      {
        "regionId": "3",
        "year": 2100,
        "scenarioValue": 25021.5607178457
      },
      {
        "regionId": "4",
        "year": 2000,
        "scenarioValue": 43636.7066764589
      },
      {
        "regionId": "4",
        "year": 2010,
        "scenarioValue": 47445.7619347846
      },
      {
        "regionId": "4",
        "year": 2020,
        "scenarioValue": 55562.3878632178
      },
      {
        "regionId": "4",
        "year": 2030,
        "scenarioValue": 66641.0723051909
      },
      {
        "regionId": "4",
        "year": 2040,
        "scenarioValue": 76713.3119916462
      },
      {
        "regionId": "4",
        "year": 2050,
        "scenarioValue": 85056.1158115754
      },
      {
        "regionId": "4",
        "year": 2060,
        "scenarioValue": 93056.0479907559
      },
      {
        "regionId": "4",
        "year": 2070,
        "scenarioValue": 102027.978764552
      },
      {
        "regionId": "4",
        "year": 2080,
        "scenarioValue": 111228.497640638
      },
      {
        "regionId": "4",
        "year": 2090,
        "scenarioValue": 120754.343580547
      },
      {
        "regionId": "4",
        "year": 2100,
        "scenarioValue": 131218.87448365
      },
      {
        "regionId": "5",
        "year": 2000,
        "scenarioValue": 1889.41652421013
      },
      {
        "regionId": "5",
        "year": 2010,
        "scenarioValue": 4725.75086928048
      },
      {
        "regionId": "5",
        "year": 2020,
        "scenarioValue": 9775.3502702531
      },
      {
        "regionId": "5",
        "year": 2030,
        "scenarioValue": 15208.1402765357
      },
      {
        "regionId": "5",
        "year": 2040,
        "scenarioValue": 19100.648040772
      },
      {
        "regionId": "5",
        "year": 2050,
        "scenarioValue": 22201.7189838158
      },
      {
        "regionId": "5",
        "year": 2060,
        "scenarioValue": 24945.7244157525
      },
      {
        "regionId": "5",
        "year": 2070,
        "scenarioValue": 27457.9549265248
      },
      {
        "regionId": "5",
        "year": 2080,
        "scenarioValue": 29951.8177876694
      },
      {
        "regionId": "5",
        "year": 2090,
        "scenarioValue": 32452.9231631911
      },
      {
        "regionId": "5",
        "year": 2100,
        "scenarioValue": 34838.9880541951
      },
      {
        "regionId": "6",
        "year": 2000,
        "scenarioValue": 7080.3140400346
      },
      {
        "regionId": "6",
        "year": 2010,
        "scenarioValue": 8908.83260652436
      },
      {
        "regionId": "6",
        "year": 2020,
        "scenarioValue": 8933.21606112464
      },
      {
        "regionId": "6",
        "year": 2030,
        "scenarioValue": 11026.3001886881
      },
      {
        "regionId": "6",
        "year": 2040,
        "scenarioValue": 13207.8548025842
      },
      {
        "regionId": "6",
        "year": 2050,
        "scenarioValue": 16203.5263108327
      },
      {
        "regionId": "6",
        "year": 2060,
        "scenarioValue": 19753.8020250508
      },
      {
        "regionId": "6",
        "year": 2070,
        "scenarioValue": 23140.0877071013
      },
      {
        "regionId": "6",
        "year": 2080,
        "scenarioValue": 26718.9465665784
      },
      {
        "regionId": "6",
        "year": 2090,
        "scenarioValue": 30712.8059120098
      },
      {
        "regionId": "6",
        "year": 2100,
        "scenarioValue": 35144.1033603725
      },
      {
        "regionId": "7",
        "year": 2000,
        "scenarioValue": 31271.07759805
      },
      {
        "regionId": "7",
        "year": 2010,
        "scenarioValue": 34806.5619338586
      },
      {
        "regionId": "7",
        "year": 2020,
        "scenarioValue": 39788.8333839316
      },
      {
        "regionId": "7",
        "year": 2030,
        "scenarioValue": 51119.4404815308
      },
      {
        "regionId": "7",
        "year": 2040,
        "scenarioValue": 62580.7447899963
      },
      {
        "regionId": "7",
        "year": 2050,
        "scenarioValue": 73175.8864031575
      },
      {
        "regionId": "7",
        "year": 2060,
        "scenarioValue": 83479.1878206135
      },
      {
        "regionId": "7",
        "year": 2070,
        "scenarioValue": 94266.5509587908
      },
      {
        "regionId": "7",
        "year": 2080,
        "scenarioValue": 105522.121566849
      },
      {
        "regionId": "7",
        "year": 2090,
        "scenarioValue": 117614.14150177
      },
      {
        "regionId": "7",
        "year": 2100,
        "scenarioValue": 130822.59506243
      },
      {
        "regionId": "8",
        "year": 2000,
        "scenarioValue": 770.347836875187
      },
      {
        "regionId": "8",
        "year": 2010,
        "scenarioValue": 1345.7213825728
      },
      {
        "regionId": "8",
        "year": 2020,
        "scenarioValue": 2569.67012693356
      },
      {
        "regionId": "8",
        "year": 2030,
        "scenarioValue": 4537.61195364189
      },
      {
        "regionId": "8",
        "year": 2040,
        "scenarioValue": 6112.60099181574
      },
      {
        "regionId": "8",
        "year": 2050,
        "scenarioValue": 7322.35101858888
      },
      {
        "regionId": "8",
        "year": 2060,
        "scenarioValue": 8605.88493154297
      },
      {
        "regionId": "8",
        "year": 2070,
        "scenarioValue": 10054.0021124356
      },
      {
        "regionId": "8",
        "year": 2080,
        "scenarioValue": 11518.5978553032
      },
      {
        "regionId": "8",
        "year": 2090,
        "scenarioValue": 13101.4224755164
      },
      {
        "regionId": "8",
        "year": 2100,
        "scenarioValue": 14849.6673145311
      },
      {
        "regionId": "9",
        "year": 2000,
        "scenarioValue": 42169.6858656681
      },
      {
        "regionId": "9",
        "year": 2010,
        "scenarioValue": 44507.6637099867
      },
      {
        "regionId": "9",
        "year": 2020,
        "scenarioValue": 47210.6707825036
      },
      {
        "regionId": "9",
        "year": 2030,
        "scenarioValue": 52047.5258276539
      },
      {
        "regionId": "9",
        "year": 2040,
        "scenarioValue": 58401.2134856504
      },
      {
        "regionId": "9",
        "year": 2050,
        "scenarioValue": 65292.3261725169
      },
      {
        "regionId": "9",
        "year": 2060,
        "scenarioValue": 73033.2041721147
      },
      {
        "regionId": "9",
        "year": 2070,
        "scenarioValue": 82004.7119395529
      },
      {
        "regionId": "9",
        "year": 2080,
        "scenarioValue": 91503.2508070089
      },
      {
        "regionId": "9",
        "year": 2090,
        "scenarioValue": 102525.004851832
      },
      {
        "regionId": "9",
        "year": 2100,
        "scenarioValue": 115441.619320847
      },
      {
        "regionId": "10",
        "year": 2000,
        "scenarioValue": 8355.8155397112
      },
      {
        "regionId": "10",
        "year": 2010,
        "scenarioValue": 10584.1710371314
      },
      {
        "regionId": "10",
        "year": 2020,
        "scenarioValue": 7356.05031544101
      },
      {
        "regionId": "10",
        "year": 2030,
        "scenarioValue": 8885.09195180503
      },
      {
        "regionId": "10",
        "year": 2040,
        "scenarioValue": 10704.6088739557
      },
      {
        "regionId": "10",
        "year": 2050,
        "scenarioValue": 12577.7162867039
      },
      {
        "regionId": "10",
        "year": 2060,
        "scenarioValue": 14582.9389569494
      },
      {
        "regionId": "10",
        "year": 2070,
        "scenarioValue": 16934.1729733447
      },
      {
        "regionId": "10",
        "year": 2080,
        "scenarioValue": 19609.1009047856
      },
      {
        "regionId": "10",
        "year": 2090,
        "scenarioValue": 22752.9476024044
      },
      {
        "regionId": "10",
        "year": 2100,
        "scenarioValue": 26311.5823025553
      },
      {
        "regionId": "11",
        "year": 2000,
        "scenarioValue": 8568.07534151005
      },
      {
        "regionId": "11",
        "year": 2010,
        "scenarioValue": 8861.49371999101
      },
      {
        "regionId": "11",
        "year": 2020,
        "scenarioValue": 9454.83732777175
      },
      {
        "regionId": "11",
        "year": 2030,
        "scenarioValue": 12233.6108945413
      },
      {
        "regionId": "11",
        "year": 2040,
        "scenarioValue": 15260.249827793
      },
      {
        "regionId": "11",
        "year": 2050,
        "scenarioValue": 18854.0369910563
      },
      {
        "regionId": "11",
        "year": 2060,
        "scenarioValue": 22251.1194947499
      },
      {
        "regionId": "11",
        "year": 2070,
        "scenarioValue": 25621.02600453
      },
      {
        "regionId": "11",
        "year": 2080,
        "scenarioValue": 29504.7565118778
      },
      {
        "regionId": "11",
        "year": 2090,
        "scenarioValue": 33927.1983822385
      },
      {
        "regionId": "11",
        "year": 2100,
        "scenarioValue": 38639.4218515225
      },
      {
        "regionId": "12",
        "year": 2000,
        "scenarioValue": 1686.96711380122
      },
      {
        "regionId": "12",
        "year": 2010,
        "scenarioValue": 2360.00628625555
      },
      {
        "regionId": "12",
        "year": 2020,
        "scenarioValue": 2388.72557506933
      },
      {
        "regionId": "12",
        "year": 2030,
        "scenarioValue": 3416.34190189465
      },
      {
        "regionId": "12",
        "year": 2040,
        "scenarioValue": 4393.74011079859
      },
      {
        "regionId": "12",
        "year": 2050,
        "scenarioValue": 5432.8790588497
      },
      {
        "regionId": "12",
        "year": 2060,
        "scenarioValue": 6710.00473555457
      },
      {
        "regionId": "12",
        "year": 2070,
        "scenarioValue": 8049.67524430965
      },
      {
        "regionId": "12",
        "year": 2080,
        "scenarioValue": 9507.48313313895
      },
      {
        "regionId": "12",
        "year": 2090,
        "scenarioValue": 11159.1691403915
      },
      {
        "regionId": "12",
        "year": 2100,
        "scenarioValue": 12950.195693786
      },
      {
        "regionId": "13",
        "year": 2000,
        "scenarioValue": 2176.79404988907
      },
      {
        "regionId": "13",
        "year": 2010,
        "scenarioValue": 3690.19408187968
      },
      {
        "regionId": "13",
        "year": 2020,
        "scenarioValue": 6338.85603318064
      },
      {
        "regionId": "13",
        "year": 2030,
        "scenarioValue": 10150.0121204068
      },
      {
        "regionId": "13",
        "year": 2040,
        "scenarioValue": 12629.1736347798
      },
      {
        "regionId": "13",
        "year": 2050,
        "scenarioValue": 14263.0474535339
      },
      {
        "regionId": "13",
        "year": 2060,
        "scenarioValue": 15913.3013039802
      },
      {
        "regionId": "13",
        "year": 2070,
        "scenarioValue": 18046.8305168439
      },
      {
        "regionId": "13",
        "year": 2080,
        "scenarioValue": 20538.0927190193
      },
      {
        "regionId": "13",
        "year": 2090,
        "scenarioValue": 23292.9959285674
      },
      {
        "regionId": "13",
        "year": 2100,
        "scenarioValue": 26388.7792946802
      },
      {
        "regionId": "14",
        "year": 2000,
        "scenarioValue": 6491.00135927102
      },
      {
        "regionId": "14",
        "year": 2010,
        "scenarioValue": 10674.9823156144
      },
      {
        "regionId": "14",
        "year": 2020,
        "scenarioValue": 11175.5285990775
      },
      {
        "regionId": "14",
        "year": 2030,
        "scenarioValue": 13361.0586565574
      },
      {
        "regionId": "14",
        "year": 2040,
        "scenarioValue": 14996.5024272319
      },
      {
        "regionId": "14",
        "year": 2050,
        "scenarioValue": 16660.312092262
      },
      {
        "regionId": "14",
        "year": 2060,
        "scenarioValue": 18604.266971449
      },
      {
        "regionId": "14",
        "year": 2070,
        "scenarioValue": 21153.5149234736
      },
      {
        "regionId": "14",
        "year": 2080,
        "scenarioValue": 24095.260696277
      },
      {
        "regionId": "14",
        "year": 2090,
        "scenarioValue": 27339.9187611249
      },
      {
        "regionId": "14",
        "year": 2100,
        "scenarioValue": 31011.065907815
      },
      {
        "regionId": "15",
        "year": 2000,
        "scenarioValue": 15104.5196775249
      },
      {
        "regionId": "15",
        "year": 2010,
        "scenarioValue": 22151.2088921324
      },
      {
        "regionId": "15",
        "year": 2020,
        "scenarioValue": 22832.0613629004
      },
      {
        "regionId": "15",
        "year": 2030,
        "scenarioValue": 23377.4553486997
      },
      {
        "regionId": "15",
        "year": 2040,
        "scenarioValue": 25402.7779789196
      },
      {
        "regionId": "15",
        "year": 2050,
        "scenarioValue": 27821.921041249
      },
      {
        "regionId": "15",
        "year": 2060,
        "scenarioValue": 30506.9669757895
      },
      {
        "regionId": "15",
        "year": 2070,
        "scenarioValue": 33786.0693621092
      },
      {
        "regionId": "15",
        "year": 2080,
        "scenarioValue": 37870.8551696008
      },
      {
        "regionId": "15",
        "year": 2090,
        "scenarioValue": 42493.9538959542
      },
      {
        "regionId": "15",
        "year": 2100,
        "scenarioValue": 47557.6198868034
      },
      {
        "regionId": "16",
        "year": 2000,
        "scenarioValue": 45055.817918284
      },
      {
        "regionId": "16",
        "year": 2010,
        "scenarioValue": 48374.0867933094
      },
      {
        "regionId": "16",
        "year": 2020,
        "scenarioValue": 50637.8126907102
      },
      {
        "regionId": "16",
        "year": 2030,
        "scenarioValue": 58156.0394887653
      },
      {
        "regionId": "16",
        "year": 2040,
        "scenarioValue": 65947.7419138888
      },
      {
        "regionId": "16",
        "year": 2050,
        "scenarioValue": 73910.9851052152
      },
      {
        "regionId": "16",
        "year": 2060,
        "scenarioValue": 81924.3401151222
      },
      {
        "regionId": "16",
        "year": 2070,
        "scenarioValue": 90518.4171411409
      },
      {
        "regionId": "16",
        "year": 2080,
        "scenarioValue": 99915.7733869002
      },
      {
        "regionId": "16",
        "year": 2090,
        "scenarioValue": 109934.484741544
      },
      {
        "regionId": "16",
        "year": 2100,
        "scenarioValue": 120510.987331997
      }
    ],
    "factor": {
      "id": "4",
      "unit": "2010$GDP/capita",
      "unitShort": "2010$",
      "title": "Affluence"
    }
  },
  "5" : {
    "scenarioValuesAllRegions": [
      {
        "regionId": "1",
        "year": 2000,
        "scenarioValue": 1.16868311398683
      },
      {
        "regionId": "1",
        "year": 2010,
        "scenarioValue": 1.95568964189297
      },
      {
        "regionId": "1",
        "year": 2020,
        "scenarioValue": 1.73902356653838
      },
      {
        "regionId": "1",
        "year": 2030,
        "scenarioValue": 2.7284760706887
      },
      {
        "regionId": "1",
        "year": 2040,
        "scenarioValue": 4.21697479214653
      },
      {
        "regionId": "1",
        "year": 2050,
        "scenarioValue": 6.23504468417699
      },
      {
        "regionId": "1",
        "year": 2060,
        "scenarioValue": 8.74107103460458
      },
      {
        "regionId": "1",
        "year": 2070,
        "scenarioValue": 11.6692133443064
      },
      {
        "regionId": "1",
        "year": 2080,
        "scenarioValue": 14.9720065575222
      },
      {
        "regionId": "1",
        "year": 2090,
        "scenarioValue": 18.6279115661306
      },
      {
        "regionId": "1",
        "year": 2100,
        "scenarioValue": 22.5430253699783
      },
      {
        "regionId": "2",
        "year": 2000,
        "scenarioValue": 0.960309983072124
      },
      {
        "regionId": "2",
        "year": 2010,
        "scenarioValue": 1.28883502873952
      },
      {
        "regionId": "2",
        "year": 2020,
        "scenarioValue": 2.16693896093193
      },
      {
        "regionId": "2",
        "year": 2030,
        "scenarioValue": 3.03361612473417
      },
      {
        "regionId": "2",
        "year": 2040,
        "scenarioValue": 3.88306454218296
      },
      {
        "regionId": "2",
        "year": 2050,
        "scenarioValue": 4.6967240275025
      },
      {
        "regionId": "2",
        "year": 2060,
        "scenarioValue": 5.49053577359312
      },
      {
        "regionId": "2",
        "year": 2070,
        "scenarioValue": 6.25579546088128
      },
      {
        "regionId": "2",
        "year": 2080,
        "scenarioValue": 6.93820128801853
      },
      {
        "regionId": "2",
        "year": 2090,
        "scenarioValue": 7.50572910328794
      },
      {
        "regionId": "2",
        "year": 2100,
        "scenarioValue": 7.9357132545308
      },
      {
        "regionId": "3",
        "year": 2000,
        "scenarioValue": 0.124669622985296
      },
      {
        "regionId": "3",
        "year": 2010,
        "scenarioValue": 0.288559160063832
      },
      {
        "regionId": "3",
        "year": 2020,
        "scenarioValue": 0.528485982371926
      },
      {
        "regionId": "3",
        "year": 2030,
        "scenarioValue": 0.872032853360381
      },
      {
        "regionId": "3",
        "year": 2040,
        "scenarioValue": 1.07174584084738
      },
      {
        "regionId": "3",
        "year": 2050,
        "scenarioValue": 1.19255251682659
      },
      {
        "regionId": "3",
        "year": 2060,
        "scenarioValue": 1.30284231486122
      },
      {
        "regionId": "3",
        "year": 2070,
        "scenarioValue": 1.41882954295989
      },
      {
        "regionId": "3",
        "year": 2080,
        "scenarioValue": 1.53461681499005
      },
      {
        "regionId": "3",
        "year": 2090,
        "scenarioValue": 1.65540505580565
      },
      {
        "regionId": "3",
        "year": 2100,
        "scenarioValue": 1.79402088190882
      },
      {
        "regionId": "4",
        "year": 2000,
        "scenarioValue": 1.34268837342264
      },
      {
        "regionId": "4",
        "year": 2010,
        "scenarioValue": 1.61340613473112
      },
      {
        "regionId": "4",
        "year": 2020,
        "scenarioValue": 2.09825801526656
      },
      {
        "regionId": "4",
        "year": 2030,
        "scenarioValue": 2.75787413627802
      },
      {
        "regionId": "4",
        "year": 2040,
        "scenarioValue": 3.41681091610792
      },
      {
        "regionId": "4",
        "year": 2050,
        "scenarioValue": 4.04739527089382
      },
      {
        "regionId": "4",
        "year": 2060,
        "scenarioValue": 4.6960734618535
      },
      {
        "regionId": "4",
        "year": 2070,
        "scenarioValue": 5.38320021557529
      },
      {
        "regionId": "4",
        "year": 2080,
        "scenarioValue": 6.04215444883476
      },
      {
        "regionId": "4",
        "year": 2090,
        "scenarioValue": 6.63484740803315
      },
      {
        "regionId": "4",
        "year": 2100,
        "scenarioValue": 7.14145602489814
      },
      {
        "regionId": "5",
        "year": 2000,
        "scenarioValue": 2.39907134056788
      },
      {
        "regionId": "5",
        "year": 2010,
        "scenarioValue": 6.35738169513108
      },
      {
        "regionId": "5",
        "year": 2020,
        "scenarioValue": 13.5571986814075
      },
      {
        "regionId": "5",
        "year": 2030,
        "scenarioValue": 21.1226468626416
      },
      {
        "regionId": "5",
        "year": 2040,
        "scenarioValue": 25.7554093214172
      },
      {
        "regionId": "5",
        "year": 2050,
        "scenarioValue": 28.2495782436022
      },
      {
        "regionId": "5",
        "year": 2060,
        "scenarioValue": 29.270589603436
      },
      {
        "regionId": "5",
        "year": 2070,
        "scenarioValue": 29.2921737735716
      },
      {
        "regionId": "5",
        "year": 2080,
        "scenarioValue": 28.7935809938202
      },
      {
        "regionId": "5",
        "year": 2090,
        "scenarioValue": 27.9561163180067
      },
      {
        "regionId": "5",
        "year": 2100,
        "scenarioValue": 27.027076601791
      },
      {
        "regionId": "6",
        "year": 2000,
        "scenarioValue": 2.99288840156156
      },
      {
        "regionId": "6",
        "year": 2010,
        "scenarioValue": 4.27316964959782
      },
      {
        "regionId": "6",
        "year": 2020,
        "scenarioValue": 4.54930281164015
      },
      {
        "regionId": "6",
        "year": 2030,
        "scenarioValue": 6.02557534301297
      },
      {
        "regionId": "6",
        "year": 2040,
        "scenarioValue": 7.55622694041325
      },
      {
        "regionId": "6",
        "year": 2050,
        "scenarioValue": 9.49094007662298
      },
      {
        "regionId": "6",
        "year": 2060,
        "scenarioValue": 11.5988596888511
      },
      {
        "regionId": "6",
        "year": 2070,
        "scenarioValue": 13.4112080720539
      },
      {
        "regionId": "6",
        "year": 2080,
        "scenarioValue": 15.0876013093224
      },
      {
        "regionId": "6",
        "year": 2090,
        "scenarioValue": 16.7365443152729
      },
      {
        "regionId": "6",
        "year": 2100,
        "scenarioValue": 18.3814203805756
      },
      {
        "regionId": "7",
        "year": 2000,
        "scenarioValue": 15.6456498329002
      },
      {
        "regionId": "7",
        "year": 2010,
        "scenarioValue": 18.0304550113984
      },
      {
        "regionId": "7",
        "year": 2020,
        "scenarioValue": 21.2157640598128
      },
      {
        "regionId": "7",
        "year": 2030,
        "scenarioValue": 27.8385737779916
      },
      {
        "regionId": "7",
        "year": 2040,
        "scenarioValue": 34.5885653876653
      },
      {
        "regionId": "7",
        "year": 2050,
        "scenarioValue": 40.8202169434782
      },
      {
        "regionId": "7",
        "year": 2060,
        "scenarioValue": 46.6485040709101
      },
      {
        "regionId": "7",
        "year": 2070,
        "scenarioValue": 52.3109600573579
      },
      {
        "regionId": "7",
        "year": 2080,
        "scenarioValue": 57.8584123878327
      },
      {
        "regionId": "7",
        "year": 2090,
        "scenarioValue": 63.4087240371416
      },
      {
        "regionId": "7",
        "year": 2100,
        "scenarioValue": 68.8049664697296
      },
      {
        "regionId": "8",
        "year": 2000,
        "scenarioValue": 0.811546865004153
      },
      {
        "regionId": "8",
        "year": 2010,
        "scenarioValue": 1.65656216864857
      },
      {
        "regionId": "8",
        "year": 2020,
        "scenarioValue": 3.56693083682508
      },
      {
        "regionId": "8",
        "year": 2030,
        "scenarioValue": 6.93617094427722
      },
      {
        "regionId": "8",
        "year": 2040,
        "scenarioValue": 10.0606382834147
      },
      {
        "regionId": "8",
        "year": 2050,
        "scenarioValue": 12.6954555842743
      },
      {
        "regionId": "8",
        "year": 2060,
        "scenarioValue": 15.3124080292698
      },
      {
        "regionId": "8",
        "year": 2070,
        "scenarioValue": 17.9087113707801
      },
      {
        "regionId": "8",
        "year": 2080,
        "scenarioValue": 20.1321707757054
      },
      {
        "regionId": "8",
        "year": 2090,
        "scenarioValue": 22.068481466124
      },
      {
        "regionId": "8",
        "year": 2100,
        "scenarioValue": 23.8030663264852
      },
      {
        "regionId": "9",
        "year": 2000,
        "scenarioValue": 5.34892946425894
      },
      {
        "regionId": "9",
        "year": 2010,
        "scenarioValue": 5.70009649133799
      },
      {
        "regionId": "9",
        "year": 2020,
        "scenarioValue": 5.89250545237663
      },
      {
        "regionId": "9",
        "year": 2030,
        "scenarioValue": 6.2670425849078
      },
      {
        "regionId": "9",
        "year": 2040,
        "scenarioValue": 6.70177285233233
      },
      {
        "regionId": "9",
        "year": 2050,
        "scenarioValue": 7.09133425327089
      },
      {
        "regionId": "9",
        "year": 2060,
        "scenarioValue": 7.47969560528713
      },
      {
        "regionId": "9",
        "year": 2070,
        "scenarioValue": 7.84120855094811
      },
      {
        "regionId": "9",
        "year": 2080,
        "scenarioValue": 8.11542331407362
      },
      {
        "regionId": "9",
        "year": 2090,
        "scenarioValue": 8.37485754632674
      },
      {
        "regionId": "9",
        "year": 2100,
        "scenarioValue": 8.65131039352363
      },
      {
        "regionId": "10",
        "year": 2000,
        "scenarioValue": 1.93000686280299
      },
      {
        "regionId": "10",
        "year": 2010,
        "scenarioValue": 3.02361548072442
      },
      {
        "regionId": "10",
        "year": 2020,
        "scenarioValue": 2.21759170834443
      },
      {
        "regionId": "10",
        "year": 2030,
        "scenarioValue": 3.05976800053505
      },
      {
        "regionId": "10",
        "year": 2040,
        "scenarioValue": 4.09991872176942
      },
      {
        "regionId": "10",
        "year": 2050,
        "scenarioValue": 5.22016732361956
      },
      {
        "regionId": "10",
        "year": 2060,
        "scenarioValue": 6.38180032927916
      },
      {
        "regionId": "10",
        "year": 2070,
        "scenarioValue": 7.64450903449214
      },
      {
        "regionId": "10",
        "year": 2080,
        "scenarioValue": 8.9637318146965
      },
      {
        "regionId": "10",
        "year": 2090,
        "scenarioValue": 10.3877672160873
      },
      {
        "regionId": "10",
        "year": 2100,
        "scenarioValue": 11.8950716852507
      },
      {
        "regionId": "11",
        "year": 2000,
        "scenarioValue": 0.880871744874416
      },
      {
        "regionId": "11",
        "year": 2010,
        "scenarioValue": 1.05112860351377
      },
      {
        "regionId": "11",
        "year": 2020,
        "scenarioValue": 1.19303973853022
      },
      {
        "regionId": "11",
        "year": 2030,
        "scenarioValue": 1.67290958899584
      },
      {
        "regionId": "11",
        "year": 2040,
        "scenarioValue": 2.20202352965088
      },
      {
        "regionId": "11",
        "year": 2050,
        "scenarioValue": 2.8039535272729
      },
      {
        "regionId": "11",
        "year": 2060,
        "scenarioValue": 3.33840221115581
      },
      {
        "regionId": "11",
        "year": 2070,
        "scenarioValue": 3.83508327748807
      },
      {
        "regionId": "11",
        "year": 2080,
        "scenarioValue": 4.37912546624941
      },
      {
        "regionId": "11",
        "year": 2090,
        "scenarioValue": 4.95330310941006
      },
      {
        "regionId": "11",
        "year": 2100,
        "scenarioValue": 5.52798752660992
      },
      {
        "regionId": "12",
        "year": 2000,
        "scenarioValue": 1.47768479764599
      },
      {
        "regionId": "12",
        "year": 2010,
        "scenarioValue": 2.39870072040438
      },
      {
        "regionId": "12",
        "year": 2020,
        "scenarioValue": 2.47240740941516
      },
      {
        "regionId": "12",
        "year": 2030,
        "scenarioValue": 3.88049294536986
      },
      {
        "regionId": "12",
        "year": 2040,
        "scenarioValue": 5.32081488043698
      },
      {
        "regionId": "12",
        "year": 2050,
        "scenarioValue": 6.83896792094965
      },
      {
        "regionId": "12",
        "year": 2060,
        "scenarioValue": 8.57311807043813
      },
      {
        "regionId": "12",
        "year": 2070,
        "scenarioValue": 10.2418755022935
      },
      {
        "regionId": "12",
        "year": 2080,
        "scenarioValue": 11.8787159789257
      },
      {
        "regionId": "12",
        "year": 2090,
        "scenarioValue": 13.5458141219544
      },
      {
        "regionId": "12",
        "year": 2100,
        "scenarioValue": 15.1636172413765
      },
      {
        "regionId": "13",
        "year": 2000,
        "scenarioValue": 0.173785859314377
      },
      {
        "regionId": "13",
        "year": 2010,
        "scenarioValue": 0.279142262583948
      },
      {
        "regionId": "13",
        "year": 2020,
        "scenarioValue": 0.449951017803261
      },
      {
        "regionId": "13",
        "year": 2030,
        "scenarioValue": 0.694443529253993
      },
      {
        "regionId": "13",
        "year": 2040,
        "scenarioValue": 0.838135108272165
      },
      {
        "regionId": "13",
        "year": 2050,
        "scenarioValue": 0.920679713125615
      },
      {
        "regionId": "13",
        "year": 2060,
        "scenarioValue": 0.999530368204303
      },
      {
        "regionId": "13",
        "year": 2070,
        "scenarioValue": 1.09426956838883
      },
      {
        "regionId": "13",
        "year": 2080,
        "scenarioValue": 1.19059323492155
      },
      {
        "regionId": "13",
        "year": 2090,
        "scenarioValue": 1.28293162975363
      },
      {
        "regionId": "13",
        "year": 2100,
        "scenarioValue": 1.37422207054977
      },
      {
        "regionId": "14",
        "year": 2000,
        "scenarioValue": 0.951558450751452
      },
      {
        "regionId": "14",
        "year": 2010,
        "scenarioValue": 1.52491534187026
      },
      {
        "regionId": "14",
        "year": 2020,
        "scenarioValue": 1.58657861968244
      },
      {
        "regionId": "14",
        "year": 2030,
        "scenarioValue": 1.86563134233243
      },
      {
        "regionId": "14",
        "year": 2040,
        "scenarioValue": 2.06639806245314
      },
      {
        "regionId": "14",
        "year": 2050,
        "scenarioValue": 2.27771456769359
      },
      {
        "regionId": "14",
        "year": 2060,
        "scenarioValue": 2.51946425034151
      },
      {
        "regionId": "14",
        "year": 2070,
        "scenarioValue": 2.82245003569431
      },
      {
        "regionId": "14",
        "year": 2080,
        "scenarioValue": 3.14770847631884
      },
      {
        "regionId": "14",
        "year": 2090,
        "scenarioValue": 3.47129480526251
      },
      {
        "regionId": "14",
        "year": 2100,
        "scenarioValue": 3.80263892374809
      },
      {
        "regionId": "15",
        "year": 2000,
        "scenarioValue": 0.710034937602774
      },
      {
        "regionId": "15",
        "year": 2010,
        "scenarioValue": 1.09449933870272
      },
      {
        "regionId": "15",
        "year": 2020,
        "scenarioValue": 1.1274015259773
      },
      {
        "regionId": "15",
        "year": 2030,
        "scenarioValue": 1.16094781007178
      },
      {
        "regionId": "15",
        "year": 2040,
        "scenarioValue": 1.23533709311486
      },
      {
        "regionId": "15",
        "year": 2050,
        "scenarioValue": 1.284899779448
      },
      {
        "regionId": "15",
        "year": 2060,
        "scenarioValue": 1.30893192506322
      },
      {
        "regionId": "15",
        "year": 2070,
        "scenarioValue": 1.33090084431221
      },
      {
        "regionId": "15",
        "year": 2080,
        "scenarioValue": 1.36240401472639
      },
      {
        "regionId": "15",
        "year": 2090,
        "scenarioValue": 1.39613885525158
      },
      {
        "regionId": "15",
        "year": 2100,
        "scenarioValue": 1.42882113187912
      },
      {
        "regionId": "16",
        "year": 2000,
        "scenarioValue": 12.7130582134
      },
      {
        "regionId": "16",
        "year": 2010,
        "scenarioValue": 14.964372
      },
      {
        "regionId": "16",
        "year": 2020,
        "scenarioValue": 17.0016962487186
      },
      {
        "regionId": "16",
        "year": 2030,
        "scenarioValue": 20.9960167805894
      },
      {
        "regionId": "16",
        "year": 2040,
        "scenarioValue": 25.2733509768853
      },
      {
        "regionId": "16",
        "year": 2050,
        "scenarioValue": 29.7347588627536
      },
      {
        "regionId": "16",
        "year": 2060,
        "scenarioValue": 34.4844124846584
      },
      {
        "regionId": "16",
        "year": 2070,
        "scenarioValue": 39.6142990408146
      },
      {
        "regionId": "16",
        "year": 2080,
        "scenarioValue": 44.9166363472141
      },
      {
        "regionId": "16",
        "year": 2090,
        "scenarioValue": 50.1534311529093
      },
      {
        "regionId": "16",
        "year": 2100,
        "scenarioValue": 55.2615183509605
      }
    ],
    "factor": {
      "id": "5",
      "unit": "2010$GDP",
      "unitShort": "2010$",
      "title": "Gross Domestic Product"
    }    
  },
  "6" : {
    "scenarioValuesAllRegions": [
      {
        "regionId": "1",
        "year": 2000,
        "scenarioValue": 0.770987371036419
      },
      {
        "regionId": "1",
        "year": 2010,
        "scenarioValue": 0.624000404256368
      },
      {
        "regionId": "1",
        "year": 2020,
        "scenarioValue": 0.420466757362866
      },
      {
        "regionId": "1",
        "year": 2030,
        "scenarioValue": 0.311230743732913
      },
      {
        "regionId": "1",
        "year": 2040,
        "scenarioValue": 0.221565659282588
      },
      {
        "regionId": "1",
        "year": 2050,
        "scenarioValue": 0.205155017292205
      },
      {
        "regionId": "1",
        "year": 2060,
        "scenarioValue": 0.180053059074228
      },
      {
        "regionId": "1",
        "year": 2070,
        "scenarioValue": 0.160093515224553
      },
      {
        "regionId": "1",
        "year": 2080,
        "scenarioValue": 0.145276385743178
      },
      {
        "regionId": "1",
        "year": 2090,
        "scenarioValue": 0.141553543606587
      },
      {
        "regionId": "1",
        "year": 2100,
        "scenarioValue": 0.137830701469995
      },
      {
        "regionId": "2",
        "year": 2000,
        "scenarioValue": 0.377403426381729
      },
      {
        "regionId": "2",
        "year": 2010,
        "scenarioValue": 0.313908633749408
      },
      {
        "regionId": "2",
        "year": 2020,
        "scenarioValue": 0.261359784567458
      },
      {
        "regionId": "2",
        "year": 2030,
        "scenarioValue": 0.24649814574117
      },
      {
        "regionId": "2",
        "year": 2040,
        "scenarioValue": 0.203799368102987
      },
      {
        "regionId": "2",
        "year": 2050,
        "scenarioValue": 0.19123516620107
      },
      {
        "regionId": "2",
        "year": 2060,
        "scenarioValue": 0.172212323076893
      },
      {
        "regionId": "2",
        "year": 2070,
        "scenarioValue": 0.156062144161828
      },
      {
        "regionId": "2",
        "year": 2080,
        "scenarioValue": 0.142784629455875
      },
      {
        "regionId": "2",
        "year": 2090,
        "scenarioValue": 0.137461435824349
      },
      {
        "regionId": "2",
        "year": 2100,
        "scenarioValue": 0.132138242192823
      },
      {
        "regionId": "3",
        "year": 2000,
        "scenarioValue": 2.55749536547171
      },
      {
        "regionId": "3",
        "year": 2010,
        "scenarioValue": 1.5764994322113
      },
      {
        "regionId": "3",
        "year": 2020,
        "scenarioValue": 0.88459829701026
      },
      {
        "regionId": "3",
        "year": 2030,
        "scenarioValue": 0.793358888769139
      },
      {
        "regionId": "3",
        "year": 2040,
        "scenarioValue": 0.788492073206316
      },
      {
        "regionId": "3",
        "year": 2050,
        "scenarioValue": 0.764131547367743
      },
      {
        "regionId": "3",
        "year": 2060,
        "scenarioValue": 0.713708719547491
      },
      {
        "regionId": "3",
        "year": 2070,
        "scenarioValue": 0.673487968750251
      },
      {
        "regionId": "3",
        "year": 2080,
        "scenarioValue": 0.643469294976024
      },
      {
        "regionId": "3",
        "year": 2090,
        "scenarioValue": 0.61005785220436
      },
      {
        "regionId": "3",
        "year": 2100,
        "scenarioValue": 0.576646409432696
      },
      {
        "regionId": "4",
        "year": 2000,
        "scenarioValue": 0.398069720107542
      },
      {
        "regionId": "4",
        "year": 2010,
        "scenarioValue": 0.305309431640466
      },
      {
        "regionId": "4",
        "year": 2020,
        "scenarioValue": 0.138012574189172
      },
      {
        "regionId": "4",
        "year": 2030,
        "scenarioValue": 0.129456921679381
      },
      {
        "regionId": "4",
        "year": 2040,
        "scenarioValue": 0.119876314509838
      },
      {
        "regionId": "4",
        "year": 2050,
        "scenarioValue": 0.114602273550012
      },
      {
        "regionId": "4",
        "year": 2060,
        "scenarioValue": 0.132755552298098
      },
      {
        "regionId": "4",
        "year": 2070,
        "scenarioValue": 0.137944560281906
      },
      {
        "regionId": "4",
        "year": 2080,
        "scenarioValue": 0.130169297501437
      },
      {
        "regionId": "4",
        "year": 2090,
        "scenarioValue": 0.126175986214527
      },
      {
        "regionId": "4",
        "year": 2100,
        "scenarioValue": 0.122182674927617
      },
      {
        "regionId": "5",
        "year": 2000,
        "scenarioValue": 1.43691226130191
      },
      {
        "regionId": "5",
        "year": 2010,
        "scenarioValue": 1.3858881924217
      },
      {
        "regionId": "5",
        "year": 2020,
        "scenarioValue": 0.815410488537023
      },
      {
        "regionId": "5",
        "year": 2030,
        "scenarioValue": 0.590280692301407
      },
      {
        "regionId": "5",
        "year": 2040,
        "scenarioValue": 0.525609545981581
      },
      {
        "regionId": "5",
        "year": 2050,
        "scenarioValue": 0.499625830810289
      },
      {
        "regionId": "5",
        "year": 2060,
        "scenarioValue": 0.507817177961799
      },
      {
        "regionId": "5",
        "year": 2070,
        "scenarioValue": 0.511665780815685
      },
      {
        "regionId": "5",
        "year": 2080,
        "scenarioValue": 0.511171639371946
      },
      {
        "regionId": "5",
        "year": 2090,
        "scenarioValue": 0.519602590908916
      },
      {
        "regionId": "5",
        "year": 2100,
        "scenarioValue": 0.528033542445886
      },
      {
        "regionId": "6",
        "year": 2000,
        "scenarioValue": 0.323885871281116
      },
      {
        "regionId": "6",
        "year": 2010,
        "scenarioValue": 0.298577877326049
      },
      {
        "regionId": "6",
        "year": 2020,
        "scenarioValue": 0.235503874848405
      },
      {
        "regionId": "6",
        "year": 2030,
        "scenarioValue": 0.218265491327088
      },
      {
        "regionId": "6",
        "year": 2040,
        "scenarioValue": 0.197041355658194
      },
      {
        "regionId": "6",
        "year": 2050,
        "scenarioValue": 0.180646025173308
      },
      {
        "regionId": "6",
        "year": 2060,
        "scenarioValue": 0.158325907331381
      },
      {
        "regionId": "6",
        "year": 2070,
        "scenarioValue": 0.141610071363005
      },
      {
        "regionId": "6",
        "year": 2080,
        "scenarioValue": 0.130498517268179
      },
      {
        "regionId": "6",
        "year": 2090,
        "scenarioValue": 0.123697152091513
      },
      {
        "regionId": "6",
        "year": 2100,
        "scenarioValue": 0.116895786914847
      },
      {
        "regionId": "7",
        "year": 2000,
        "scenarioValue": 0.255170848401735
      },
      {
        "regionId": "7",
        "year": 2010,
        "scenarioValue": 0.211622931923391
      },
      {
        "regionId": "7",
        "year": 2020,
        "scenarioValue": 0.183191328346357
      },
      {
        "regionId": "7",
        "year": 2030,
        "scenarioValue": 0.121364948105338
      },
      {
        "regionId": "7",
        "year": 2040,
        "scenarioValue": 0.0878284764329467
      },
      {
        "regionId": "7",
        "year": 2050,
        "scenarioValue": 0.0772708289220386
      },
      {
        "regionId": "7",
        "year": 2060,
        "scenarioValue": 0.0895838274601208
      },
      {
        "regionId": "7",
        "year": 2070,
        "scenarioValue": 0.0937813531359333
      },
      {
        "regionId": "7",
        "year": 2080,
        "scenarioValue": 0.089863405949476
      },
      {
        "regionId": "7",
        "year": 2090,
        "scenarioValue": 0.0867387286531171
      },
      {
        "regionId": "7",
        "year": 2100,
        "scenarioValue": 0.0836140513567583
      },
      {
        "regionId": "8",
        "year": 2000,
        "scenarioValue": 1.27146503485627
      },
      {
        "regionId": "8",
        "year": 2010,
        "scenarioValue": 1.03810833094355
      },
      {
        "regionId": "8",
        "year": 2020,
        "scenarioValue": 0.633209334109317
      },
      {
        "regionId": "8",
        "year": 2030,
        "scenarioValue": 0.540916504387255
      },
      {
        "regionId": "8",
        "year": 2040,
        "scenarioValue": 0.467264488352567
      },
      {
        "regionId": "8",
        "year": 2050,
        "scenarioValue": 0.395615420546335
      },
      {
        "regionId": "8",
        "year": 2060,
        "scenarioValue": 0.358976430039232
      },
      {
        "regionId": "8",
        "year": 2070,
        "scenarioValue": 0.331811000369137
      },
      {
        "regionId": "8",
        "year": 2080,
        "scenarioValue": 0.314119131536048
      },
      {
        "regionId": "8",
        "year": 2090,
        "scenarioValue": 0.302122640946619
      },
      {
        "regionId": "8",
        "year": 2100,
        "scenarioValue": 0.290126150357189
      },
      {
        "regionId": "9",
        "year": 2000,
        "scenarioValue": 0.228181724054403
      },
      {
        "regionId": "9",
        "year": 2010,
        "scenarioValue": 0.205582693166819
      },
      {
        "regionId": "9",
        "year": 2020,
        "scenarioValue": 0.23409091618976
      },
      {
        "regionId": "9",
        "year": 2030,
        "scenarioValue": 0.234133012033626
      },
      {
        "regionId": "9",
        "year": 2040,
        "scenarioValue": 0.207300281673454
      },
      {
        "regionId": "9",
        "year": 2050,
        "scenarioValue": 0.193891029655779
      },
      {
        "regionId": "9",
        "year": 2060,
        "scenarioValue": 0.184295195219391
      },
      {
        "regionId": "9",
        "year": 2070,
        "scenarioValue": 0.176097324131462
      },
      {
        "regionId": "9",
        "year": 2080,
        "scenarioValue": 0.169297416391992
      },
      {
        "regionId": "9",
        "year": 2090,
        "scenarioValue": 0.164232703993374
      },
      {
        "regionId": "9",
        "year": 2100,
        "scenarioValue": 0.159167991594757
      },
      {
        "regionId": "10",
        "year": 2000,
        "scenarioValue": 0.756178562548385
      },
      {
        "regionId": "10",
        "year": 2010,
        "scenarioValue": 0.760861564345503
      },
      {
        "regionId": "10",
        "year": 2020,
        "scenarioValue": 0.612901822678037
      },
      {
        "regionId": "10",
        "year": 2030,
        "scenarioValue": 0.459118004210107
      },
      {
        "regionId": "10",
        "year": 2040,
        "scenarioValue": 0.329644339733818
      },
      {
        "regionId": "10",
        "year": 2050,
        "scenarioValue": 0.290217708759101
      },
      {
        "regionId": "10",
        "year": 2060,
        "scenarioValue": 0.262317815638916
      },
      {
        "regionId": "10",
        "year": 2070,
        "scenarioValue": 0.238989187110795
      },
      {
        "regionId": "10",
        "year": 2080,
        "scenarioValue": 0.220231823174737
      },
      {
        "regionId": "10",
        "year": 2090,
        "scenarioValue": 0.205598102031693
      },
      {
        "regionId": "10",
        "year": 2100,
        "scenarioValue": 0.190964380888649
      },
      {
        "regionId": "11",
        "year": 2000,
        "scenarioValue": 0.434238513410977
      },
      {
        "regionId": "11",
        "year": 2010,
        "scenarioValue": 0.423509357001499
      },
      {
        "regionId": "11",
        "year": 2020,
        "scenarioValue": 0.170756877093612
      },
      {
        "regionId": "11",
        "year": 2030,
        "scenarioValue": 0.150657150850111
      },
      {
        "regionId": "11",
        "year": 2040,
        "scenarioValue": 0.123629223908957
      },
      {
        "regionId": "11",
        "year": 2050,
        "scenarioValue": 0.103634146277246
      },
      {
        "regionId": "11",
        "year": 2060,
        "scenarioValue": 0.0924225894156942
      },
      {
        "regionId": "11",
        "year": 2070,
        "scenarioValue": 0.0837067160433963
      },
      {
        "regionId": "11",
        "year": 2080,
        "scenarioValue": 0.0774865261603524
      },
      {
        "regionId": "11",
        "year": 2090,
        "scenarioValue": 0.0729109767536966
      },
      {
        "regionId": "11",
        "year": 2100,
        "scenarioValue": 0.0683354273470408
      },
      {
        "regionId": "12",
        "year": 2000,
        "scenarioValue": 0.702315946737892
      },
      {
        "regionId": "12",
        "year": 2010,
        "scenarioValue": 0.673852787048711
      },
      {
        "regionId": "12",
        "year": 2020,
        "scenarioValue": 0.758629339508279
      },
      {
        "regionId": "12",
        "year": 2030,
        "scenarioValue": 0.653818001055129
      },
      {
        "regionId": "12",
        "year": 2040,
        "scenarioValue": 0.55851033474706
      },
      {
        "regionId": "12",
        "year": 2050,
        "scenarioValue": 0.46587965272362
      },
      {
        "regionId": "12",
        "year": 2060,
        "scenarioValue": 0.423700258694384
      },
      {
        "regionId": "12",
        "year": 2070,
        "scenarioValue": 0.390143627456182
      },
      {
        "regionId": "12",
        "year": 2080,
        "scenarioValue": 0.365209759009015
      },
      {
        "regionId": "12",
        "year": 2090,
        "scenarioValue": 0.348719399536493
      },
      {
        "regionId": "12",
        "year": 2100,
        "scenarioValue": 0.332229040063971
      },
      {
        "regionId": "13",
        "year": 2000,
        "scenarioValue": 2.80192315818595
      },
      {
        "regionId": "13",
        "year": 2010,
        "scenarioValue": 1.63077317202407
      },
      {
        "regionId": "13",
        "year": 2020,
        "scenarioValue": 1.01566477664869
      },
      {
        "regionId": "13",
        "year": 2030,
        "scenarioValue": 0.876768041501097
      },
      {
        "regionId": "13",
        "year": 2040,
        "scenarioValue": 0.788200844326736
      },
      {
        "regionId": "13",
        "year": 2050,
        "scenarioValue": 0.76320786695137
      },
      {
        "regionId": "13",
        "year": 2060,
        "scenarioValue": 0.709453468556877
      },
      {
        "regionId": "13",
        "year": 2070,
        "scenarioValue": 0.647774182195143
      },
      {
        "regionId": "13",
        "year": 2080,
        "scenarioValue": 0.578170007866169
      },
      {
        "regionId": "13",
        "year": 2090,
        "scenarioValue": 0.54798046022398
      },
      {
        "regionId": "13",
        "year": 2100,
        "scenarioValue": 0.517790912581789
      },
      {
        "regionId": "14",
        "year": 2000,
        "scenarioValue": 1.6372081817672
      },
      {
        "regionId": "14",
        "year": 2010,
        "scenarioValue": 1.09843929168266
      },
      {
        "regionId": "14",
        "year": 2020,
        "scenarioValue": 0.808916736982678
      },
      {
        "regionId": "14",
        "year": 2030,
        "scenarioValue": 0.693887106982021
      },
      {
        "regionId": "14",
        "year": 2040,
        "scenarioValue": 0.644976892021367
      },
      {
        "regionId": "14",
        "year": 2050,
        "scenarioValue": 0.595887219255202
      },
      {
        "regionId": "14",
        "year": 2060,
        "scenarioValue": 0.558300228685997
      },
      {
        "regionId": "14",
        "year": 2070,
        "scenarioValue": 0.527082042165282
      },
      {
        "regionId": "14",
        "year": 2080,
        "scenarioValue": 0.502232659693057
      },
      {
        "regionId": "14",
        "year": 2090,
        "scenarioValue": 0.470698708490301
      },
      {
        "regionId": "14",
        "year": 2100,
        "scenarioValue": 0.439164757287545
      },
      {
        "regionId": "15",
        "year": 2000,
        "scenarioValue": 0.630336612042021
      },
      {
        "regionId": "15",
        "year": 2010,
        "scenarioValue": 0.517786073467816
      },
      {
        "regionId": "15",
        "year": 2020,
        "scenarioValue": 0.577566541286652
      },
      {
        "regionId": "15",
        "year": 2030,
        "scenarioValue": 0.523421720456039
      },
      {
        "regionId": "15",
        "year": 2040,
        "scenarioValue": 0.475115256613952
      },
      {
        "regionId": "15",
        "year": 2050,
        "scenarioValue": 0.458758192217321
      },
      {
        "regionId": "15",
        "year": 2060,
        "scenarioValue": 0.456853442861669
      },
      {
        "regionId": "15",
        "year": 2070,
        "scenarioValue": 0.465647235976878
      },
      {
        "regionId": "15",
        "year": 2080,
        "scenarioValue": 0.485139571562948
      },
      {
        "regionId": "15",
        "year": 2090,
        "scenarioValue": 0.47604526606169
      },
      {
        "regionId": "15",
        "year": 2100,
        "scenarioValue": 0.466950960560433
      },
      {
        "regionId": "16",
        "year": 2000,
        "scenarioValue": 0.448501784959191
      },
      {
        "regionId": "16",
        "year": 2010,
        "scenarioValue": 0.361449782456624
      },
      {
        "regionId": "16",
        "year": 2020,
        "scenarioValue": 0.331004443184552
      },
      {
        "regionId": "16",
        "year": 2030,
        "scenarioValue": 0.249369345676299
      },
      {
        "regionId": "16",
        "year": 2040,
        "scenarioValue": 0.21269233371215
      },
      {
        "regionId": "16",
        "year": 2050,
        "scenarioValue": 0.188169745240768
      },
      {
        "regionId": "16",
        "year": 2060,
        "scenarioValue": 0.177078319804574
      },
      {
        "regionId": "16",
        "year": 2070,
        "scenarioValue": 0.165892397459634
      },
      {
        "regionId": "16",
        "year": 2080,
        "scenarioValue": 0.154611978205949
      },
      {
        "regionId": "16",
        "year": 2090,
        "scenarioValue": 0.148723679346938
      },
      {
        "regionId": "16",
        "year": 2100,
        "scenarioValue": 0.142835380487927
      }
    ],
    "factor": {
      "id": "6",
      "unit": "kgCO2/2010$GDP",
      "unitShort": "tCO2/2010$GDP",
      "title": "Technology Factor"
    }    
  },
  "8" : {
    "scenarioValuesAllRegions": [
      {
        "regionId": "1",
        "year": 2000,
        "scenarioValue": 0.901039921627366
      },
      {
        "regionId": "1",
        "year": 2010,
        "scenarioValue": 1.2203511271412
      },
      {
        "regionId": "1",
        "year": 2020,
        "scenarioValue": 0.7312016
      },
      {
        "regionId": "1",
        "year": 2030,
        "scenarioValue": 0.849185636737899
      },
      {
        "regionId": "1",
        "year": 2040,
        "scenarioValue": 0.9343368
      },
      {
        "regionId": "1",
        "year": 2050,
        "scenarioValue": 1.2791507
      },
      {
        "regionId": "1",
        "year": 2060,
        "scenarioValue": 1.57385657936568
      },
      {
        "regionId": "1",
        "year": 2070,
        "scenarioValue": 1.86816538419528
      },
      {
        "regionId": "1",
        "year": 2080,
        "scenarioValue": 2.17507899999999
      },
      {
        "regionId": "1",
        "year": 2090,
        "scenarioValue": 2.63684689217591
      },
      {
        "regionId": "1",
        "year": 2100,
        "scenarioValue": 3.107121
      },
      {
        "regionId": "2",
        "year": 2000,
        "scenarioValue": 0.362424278
      },
      {
        "regionId": "2",
        "year": 2010,
        "scenarioValue": 0.404576443
      },
      {
        "regionId": "2",
        "year": 2020,
        "scenarioValue": 0.5663507
      },
      {
        "regionId": "2",
        "year": 2030,
        "scenarioValue": 0.747780749637487
      },
      {
        "regionId": "2",
        "year": 2040,
        "scenarioValue": 0.7913661
      },
      {
        "regionId": "2",
        "year": 2050,
        "scenarioValue": 0.8981788
      },
      {
        "regionId": "2",
        "year": 2060,
        "scenarioValue": 0.945537920507258
      },
      {
        "regionId": "2",
        "year": 2070,
        "scenarioValue": 0.976292853062965
      },
      {
        "regionId": "2",
        "year": 2080,
        "scenarioValue": 0.990668499999999
      },
      {
        "regionId": "2",
        "year": 2090,
        "scenarioValue": 1.03174829944657
      },
      {
        "regionId": "2",
        "year": 2100,
        "scenarioValue": 1.04861119999999
      },
      {
        "regionId": "3",
        "year": 2000,
        "scenarioValue": 0.318841983
      },
      {
        "regionId": "3",
        "year": 2010,
        "scenarioValue": 0.454913352
      },
      {
        "regionId": "3",
        "year": 2020,
        "scenarioValue": 0.4674978
      },
      {
        "regionId": "3",
        "year": 2030,
        "scenarioValue": 0.691835015512173
      },
      {
        "regionId": "3",
        "year": 2040,
        "scenarioValue": 0.8450631
      },
      {
        "regionId": "3",
        "year": 2050,
        "scenarioValue": 0.911267
      },
      {
        "regionId": "3",
        "year": 2060,
        "scenarioValue": 0.929849920311891
      },
      {
        "regionId": "3",
        "year": 2070,
        "scenarioValue": 0.955564626890903
      },
      {
        "regionId": "3",
        "year": 2080,
        "scenarioValue": 0.9874788
      },
      {
        "regionId": "3",
        "year": 2090,
        "scenarioValue": 1.00989285287303
      },
      {
        "regionId": "3",
        "year": 2100,
        "scenarioValue": 1.0345157
      },
      {
        "regionId": "4",
        "year": 2000,
        "scenarioValue": 0.534483585
      },
      {
        "regionId": "4",
        "year": 2010,
        "scenarioValue": 0.49258811
      },
      {
        "regionId": "4",
        "year": 2020,
        "scenarioValue": 0.28958599
      },
      {
        "regionId": "4",
        "year": 2030,
        "scenarioValue": 0.357025896061735
      },
      {
        "regionId": "4",
        "year": 2040,
        "scenarioValue": 0.4095947
      },
      {
        "regionId": "4",
        "year": 2050,
        "scenarioValue": 0.4638407
      },
      {
        "regionId": "4",
        "year": 2060,
        "scenarioValue": 0.623429826060804
      },
      {
        "regionId": "4",
        "year": 2070,
        "scenarioValue": 0.742583186646997
      },
      {
        "regionId": "4",
        "year": 2080,
        "scenarioValue": 0.786503
      },
      {
        "regionId": "4",
        "year": 2090,
        "scenarioValue": 0.837158415091477
      },
      {
        "regionId": "4",
        "year": 2100,
        "scenarioValue": 0.8725622
      },
      {
        "regionId": "5",
        "year": 2000,
        "scenarioValue": 3.447255025
      },
      {
        "regionId": "5",
        "year": 2010,
        "scenarioValue": 8.810620226
      },
      {
        "regionId": "5",
        "year": 2020,
        "scenarioValue": 11.054682
      },
      {
        "regionId": "5",
        "year": 2030,
        "scenarioValue": 12.4682906133182
      },
      {
        "regionId": "5",
        "year": 2040,
        "scenarioValue": 13.5372889999999
      },
      {
        "regionId": "5",
        "year": 2050,
        "scenarioValue": 14.114219
      },
      {
        "regionId": "5",
        "year": 2060,
        "scenarioValue": 14.8641082096948
      },
      {
        "regionId": "5",
        "year": 2070,
        "scenarioValue": 14.9878029656432
      },
      {
        "regionId": "5",
        "year": 2080,
        "scenarioValue": 14.718462
      },
      {
        "regionId": "5",
        "year": 2090,
        "scenarioValue": 14.5260704705873
      },
      {
        "regionId": "5",
        "year": 2100,
        "scenarioValue": 14.271203
      },
      {
        "regionId": "6",
        "year": 2000,
        "scenarioValue": 0.969354267586915
      },
      {
        "regionId": "6",
        "year": 2010,
        "scenarioValue": 1.27587392343101
      },
      {
        "regionId": "6",
        "year": 2020,
        "scenarioValue": 1.07137844
      },
      {
        "regionId": "6",
        "year": 2030,
        "scenarioValue": 1.31517516277111
      },
      {
        "regionId": "6",
        "year": 2040,
        "scenarioValue": 1.48888919999999
      },
      {
        "regionId": "6",
        "year": 2050,
        "scenarioValue": 1.71450059999999
      },
      {
        "regionId": "6",
        "year": 2060,
        "scenarioValue": 1.83639998424672
      },
      {
        "regionId": "6",
        "year": 2070,
        "scenarioValue": 1.89916213214765
      },
      {
        "regionId": "6",
        "year": 2080,
        "scenarioValue": 1.9689096
      },
      {
        "regionId": "6",
        "year": 2090,
        "scenarioValue": 2.07026286765266
      },
      {
        "regionId": "6",
        "year": 2100,
        "scenarioValue": 2.1487106
      },
      {
        "regionId": "7",
        "year": 2000,
        "scenarioValue": 3.9923137416576
      },
      {
        "regionId": "7",
        "year": 2010,
        "scenarioValue": 3.81565775342493
      },
      {
        "regionId": "7",
        "year": 2020,
        "scenarioValue": 3.886544
      },
      {
        "regionId": "7",
        "year": 2030,
        "scenarioValue": 3.37862706189257
      },
      {
        "regionId": "7",
        "year": 2040,
        "scenarioValue": 3.037861
      },
      {
        "regionId": "7",
        "year": 2050,
        "scenarioValue": 3.154212
      },
      {
        "regionId": "7",
        "year": 2060,
        "scenarioValue": 4.17895153996115
      },
      {
        "regionId": "7",
        "year": 2070,
        "scenarioValue": 4.90579261801879
      },
      {
        "regionId": "7",
        "year": 2080,
        "scenarioValue": 5.199354
      },
      {
        "regionId": "7",
        "year": 2090,
        "scenarioValue": 5.49999210849801
      },
      {
        "regionId": "7",
        "year": 2100,
        "scenarioValue": 5.753062
      },
      {
        "regionId": "8",
        "year": 2000,
        "scenarioValue": 1.031853463
      },
      {
        "regionId": "8",
        "year": 2010,
        "scenarioValue": 1.719690988
      },
      {
        "regionId": "8",
        "year": 2020,
        "scenarioValue": 2.2586139
      },
      {
        "regionId": "8",
        "year": 2030,
        "scenarioValue": 3.75188934101088
      },
      {
        "regionId": "8",
        "year": 2040,
        "scenarioValue": 4.700979
      },
      {
        "regionId": "8",
        "year": 2050,
        "scenarioValue": 5.022518
      },
      {
        "regionId": "8",
        "year": 2060,
        "scenarioValue": 5.49679356965133
      },
      {
        "regionId": "8",
        "year": 2070,
        "scenarioValue": 5.94230743526069
      },
      {
        "regionId": "8",
        "year": 2080,
        "scenarioValue": 6.3239
      },
      {
        "regionId": "8",
        "year": 2090,
        "scenarioValue": 6.6673879022269
      },
      {
        "regionId": "8",
        "year": 2100,
        "scenarioValue": 6.905892
      },
      {
        "regionId": "9",
        "year": 2000,
        "scenarioValue": 1.220527947
      },
      {
        "regionId": "9",
        "year": 2010,
        "scenarioValue": 1.171841188
      },
      {
        "regionId": "9",
        "year": 2020,
        "scenarioValue": 1.379382
      },
      {
        "regionId": "9",
        "year": 2030,
        "scenarioValue": 1.46732155694747
      },
      {
        "regionId": "9",
        "year": 2040,
        "scenarioValue": 1.3892794
      },
      {
        "regionId": "9",
        "year": 2050,
        "scenarioValue": 1.37494609999999
      },
      {
        "regionId": "9",
        "year": 2060,
        "scenarioValue": 1.37847196175801
      },
      {
        "regionId": "9",
        "year": 2070,
        "scenarioValue": 1.3808158437787
      },
      {
        "regionId": "9",
        "year": 2080,
        "scenarioValue": 1.3739202
      },
      {
        "regionId": "9",
        "year": 2090,
        "scenarioValue": 1.37542550039256
      },
      {
        "regionId": "9",
        "year": 2100,
        "scenarioValue": 1.3770117
      },
      {
        "regionId": "10",
        "year": 2000,
        "scenarioValue": 1.45942981522288
      },
      {
        "regionId": "10",
        "year": 2010,
        "scenarioValue": 2.30055280464326
      },
      {
        "regionId": "10",
        "year": 2020,
        "scenarioValue": 1.359166
      },
      {
        "regionId": "10",
        "year": 2030,
        "scenarioValue": 1.4047945777516
      },
      {
        "regionId": "10",
        "year": 2040,
        "scenarioValue": 1.351515
      },
      {
        "regionId": "10",
        "year": 2050,
        "scenarioValue": 1.514985
      },
      {
        "regionId": "10",
        "year": 2060,
        "scenarioValue": 1.67405992222023
      },
      {
        "regionId": "10",
        "year": 2070,
        "scenarioValue": 1.8269550000144
      },
      {
        "regionId": "10",
        "year": 2080,
        "scenarioValue": 1.974099
      },
      {
        "regionId": "10",
        "year": 2090,
        "scenarioValue": 2.1357052239746
      },
      {
        "regionId": "10",
        "year": 2100,
        "scenarioValue": 2.271535
      },
      {
        "regionId": "11",
        "year": 2000,
        "scenarioValue": 0.382508437
      },
      {
        "regionId": "11",
        "year": 2010,
        "scenarioValue": 0.445162799
      },
      {
        "regionId": "11",
        "year": 2020,
        "scenarioValue": 0.20371974
      },
      {
        "regionId": "11",
        "year": 2030,
        "scenarioValue": 0.252035792307944
      },
      {
        "regionId": "11",
        "year": 2040,
        "scenarioValue": 0.27223446
      },
      {
        "regionId": "11",
        "year": 2050,
        "scenarioValue": 0.29058533
      },
      {
        "regionId": "11",
        "year": 2060,
        "scenarioValue": 0.308543776866099
      },
      {
        "regionId": "11",
        "year": 2070,
        "scenarioValue": 0.321022226911472
      },
      {
        "regionId": "11",
        "year": 2080,
        "scenarioValue": 0.33932322
      },
      {
        "regionId": "11",
        "year": 2090,
        "scenarioValue": 0.36115016786421
      },
      {
        "regionId": "11",
        "year": 2100,
        "scenarioValue": 0.37775739
      },
      {
        "regionId": "12",
        "year": 2000,
        "scenarioValue": 1.03780159763893
      },
      {
        "regionId": "12",
        "year": 2010,
        "scenarioValue": 1.61637116574025
      },
      {
        "regionId": "12",
        "year": 2020,
        "scenarioValue": 1.8756408
      },
      {
        "regionId": "12",
        "year": 2030,
        "scenarioValue": 2.53713614065025
      },
      {
        "regionId": "12",
        "year": 2040,
        "scenarioValue": 2.9717301
      },
      {
        "regionId": "12",
        "year": 2050,
        "scenarioValue": 3.186136
      },
      {
        "regionId": "12",
        "year": 2060,
        "scenarioValue": 3.63243234426214
      },
      {
        "regionId": "12",
        "year": 2070,
        "scenarioValue": 3.99580246041939
      },
      {
        "regionId": "12",
        "year": 2080,
        "scenarioValue": 4.338223
      },
      {
        "regionId": "12",
        "year": 2090,
        "scenarioValue": 4.7236881668409
      },
      {
        "regionId": "12",
        "year": 2100,
        "scenarioValue": 5.037794
      },
      {
        "regionId": "13",
        "year": 2000,
        "scenarioValue": 0.486934623778197
      },
      {
        "regionId": "13",
        "year": 2010,
        "scenarioValue": 0.455217713
      },
      {
        "regionId": "13",
        "year": 2020,
        "scenarioValue": 0.4569994
      },
      {
        "regionId": "13",
        "year": 2030,
        "scenarioValue": 0.608865893077133
      },
      {
        "regionId": "13",
        "year": 2040,
        "scenarioValue": 0.6606188
      },
      {
        "regionId": "13",
        "year": 2050,
        "scenarioValue": 0.70267
      },
      {
        "regionId": "13",
        "year": 2060,
        "scenarioValue": 0.709120286650475
      },
      {
        "regionId": "13",
        "year": 2070,
        "scenarioValue": 0.708839574764109
      },
      {
        "regionId": "13",
        "year": 2080,
        "scenarioValue": 0.6883653
      },
      {
        "regionId": "13",
        "year": 2090,
        "scenarioValue": 0.703021464908297
      },
      {
        "regionId": "13",
        "year": 2100,
        "scenarioValue": 0.7115597
      },
      {
        "regionId": "14",
        "year": 2000,
        "scenarioValue": 1.557899281
      },
      {
        "regionId": "14",
        "year": 2010,
        "scenarioValue": 1.675026928
      },
      {
        "regionId": "14",
        "year": 2020,
        "scenarioValue": 1.28341
      },
      {
        "regionId": "14",
        "year": 2030,
        "scenarioValue": 1.29453753482603
      },
      {
        "regionId": "14",
        "year": 2040,
        "scenarioValue": 1.332779
      },
      {
        "regionId": "14",
        "year": 2050,
        "scenarioValue": 1.357261
      },
      {
        "regionId": "14",
        "year": 2060,
        "scenarioValue": 1.40661746713186
      },
      {
        "regionId": "14",
        "year": 2070,
        "scenarioValue": 1.48766272872323
      },
      {
        "regionId": "14",
        "year": 2080,
        "scenarioValue": 1.58088199999999
      },
      {
        "regionId": "14",
        "year": 2090,
        "scenarioValue": 1.63393398162615
      },
      {
        "regionId": "14",
        "year": 2100,
        "scenarioValue": 1.669985
      },
      {
        "regionId": "15",
        "year": 2000,
        "scenarioValue": 0.447561017
      },
      {
        "regionId": "15",
        "year": 2010,
        "scenarioValue": 0.566716515
      },
      {
        "regionId": "15",
        "year": 2020,
        "scenarioValue": 0.6511494
      },
      {
        "regionId": "15",
        "year": 2030,
        "scenarioValue": 0.607665300107439
      },
      {
        "regionId": "15",
        "year": 2040,
        "scenarioValue": 0.5869275
      },
      {
        "regionId": "15",
        "year": 2050,
        "scenarioValue": 0.5894583
      },
      {
        "regionId": "15",
        "year": 2060,
        "scenarioValue": 0.597990056436686
      },
      {
        "regionId": "15",
        "year": 2070,
        "scenarioValue": 0.619730299513272
      },
      {
        "regionId": "15",
        "year": 2080,
        "scenarioValue": 0.6609561
      },
      {
        "regionId": "15",
        "year": 2090,
        "scenarioValue": 0.6646252928073
      },
      {
        "regionId": "15",
        "year": 2100,
        "scenarioValue": 0.6671894
      },
      {
        "regionId": "16",
        "year": 2000,
        "scenarioValue": 5.701829301
      },
      {
        "regionId": "16",
        "year": 2010,
        "scenarioValue": 5.408869004
      },
      {
        "regionId": "16",
        "year": 2020,
        "scenarioValue": 5.627637
      },
      {
        "regionId": "16",
        "year": 2030,
        "scenarioValue": 5.23576296638419
      },
      {
        "regionId": "16",
        "year": 2040,
        "scenarioValue": 5.375448
      },
      {
        "regionId": "16",
        "year": 2050,
        "scenarioValue": 5.595182
      },
      {
        "regionId": "16",
        "year": 2060,
        "scenarioValue": 6.10644182223117
      },
      {
        "regionId": "16",
        "year": 2070,
        "scenarioValue": 6.57171104156364
      },
      {
        "regionId": "16",
        "year": 2080,
        "scenarioValue": 6.94465
      },
      {
        "regionId": "16",
        "year": 2090,
        "scenarioValue": 7.45900281293401
      },
      {
        "regionId": "16",
        "year": 2100,
        "scenarioValue": 7.89329999999999
      }
    ],
    "factor": {
      "id": "8",
      "unit": "GtCO2",
      "unitShort": "ktCO2",
      "title": "Impact"
    }    
  },
  "12": {
    "scenarioValuesAllRegions": [
      {
        "regionId": "1",
        "year": 2010,
        "scenarioValue": 21.7818
      },
      {
        "regionId": "1",
        "year": 2020,
        "scenarioValue": 21.361
      },
      {
        "regionId": "1",
        "year": 2030,
        "scenarioValue": 25.6221818181818
      },
      {
        "regionId": "1",
        "year": 2040,
        "scenarioValue": 29.644
      },
      {
        "regionId": "1",
        "year": 2050,
        "scenarioValue": 32.863
      },
      {
        "regionId": "1",
        "year": 2060,
        "scenarioValue": 38.3083333333333
      },
      {
        "regionId": "1",
        "year": 2070,
        "scenarioValue": 43.8499
      },
      {
        "regionId": "1",
        "year": 2080,
        "scenarioValue": 49.4877
      },
      {
        "regionId": "1",
        "year": 2090,
        "scenarioValue": 62.848881
      },
      {
        "regionId": "1",
        "year": 2100,
        "scenarioValue": 76.210062
      },
      {
        "regionId": "2",
        "year": 2010,
        "scenarioValue": 6.81
      },
      {
        "regionId": "2",
        "year": 2020,
        "scenarioValue": 8.463
      },
      {
        "regionId": "2",
        "year": 2030,
        "scenarioValue": 10.2097272727273
      },
      {
        "regionId": "2",
        "year": 2040,
        "scenarioValue": 11.037
      },
      {
        "regionId": "2",
        "year": 2050,
        "scenarioValue": 12.187
      },
      {
        "regionId": "2",
        "year": 2060,
        "scenarioValue": 13.0043333333333
      },
      {
        "regionId": "2",
        "year": 2070,
        "scenarioValue": 13.784
      },
      {
        "regionId": "2",
        "year": 2080,
        "scenarioValue": 14.526
      },
      {
        "regionId": "2",
        "year": 2090,
        "scenarioValue": 14.8639
      },
      {
        "regionId": "2",
        "year": 2100,
        "scenarioValue": 15.2018
      },
      {
        "regionId": "3",
        "year": 2010,
        "scenarioValue": 6.147
      },
      {
        "regionId": "3",
        "year": 2020,
        "scenarioValue": 10.19582
      },
      {
        "regionId": "3",
        "year": 2030,
        "scenarioValue": 13.5645
      },
      {
        "regionId": "3",
        "year": 2040,
        "scenarioValue": 14.8035
      },
      {
        "regionId": "3",
        "year": 2050,
        "scenarioValue": 14.4874
      },
      {
        "regionId": "3",
        "year": 2060,
        "scenarioValue": 15.0488
      },
      {
        "regionId": "3",
        "year": 2070,
        "scenarioValue": 15.5357
      },
      {
        "regionId": "3",
        "year": 2080,
        "scenarioValue": 15.9481
      },
      {
        "regionId": "3",
        "year": 2090,
        "scenarioValue": 17.25805
      },
      {
        "regionId": "3",
        "year": 2100,
        "scenarioValue": 18.568
      },
      {
        "regionId": "4",
        "year": 2010,
        "scenarioValue": 11.3315
      },
      {
        "regionId": "4",
        "year": 2020,
        "scenarioValue": 11.7379
      },
      {
        "regionId": "4",
        "year": 2030,
        "scenarioValue": 12.8803072727273
      },
      {
        "regionId": "4",
        "year": 2040,
        "scenarioValue": 13.57338
      },
      {
        "regionId": "4",
        "year": 2050,
        "scenarioValue": 14.10458
      },
      {
        "regionId": "4",
        "year": 2060,
        "scenarioValue": 17.0834333333333
      },
      {
        "regionId": "4",
        "year": 2070,
        "scenarioValue": 19.20094
      },
      {
        "regionId": "4",
        "year": 2080,
        "scenarioValue": 20.4571
      },
      {
        "regionId": "4",
        "year": 2090,
        "scenarioValue": 22.4447
      },
      {
        "regionId": "4",
        "year": 2100,
        "scenarioValue": 24.4323
      },
      {
        "regionId": "5",
        "year": 2010,
        "scenarioValue": 99.42071
      },
      {
        "regionId": "5",
        "year": 2020,
        "scenarioValue": 125.56411
      },
      {
        "regionId": "5",
        "year": 2030,
        "scenarioValue": 174.800707272727
      },
      {
        "regionId": "5",
        "year": 2040,
        "scenarioValue": 188.40068
      },
      {
        "regionId": "5",
        "year": 2050,
        "scenarioValue": 193.23062
      },
      {
        "regionId": "5",
        "year": 2060,
        "scenarioValue": 199.847073333333
      },
      {
        "regionId": "5",
        "year": 2070,
        "scenarioValue": 201.483233333333
      },
      {
        "regionId": "5",
        "year": 2080,
        "scenarioValue": 198.1391
      },
      {
        "regionId": "5",
        "year": 2090,
        "scenarioValue": 197.5133
      },
      {
        "regionId": "5",
        "year": 2100,
        "scenarioValue": 196.8875
      },
      {
        "regionId": "6",
        "year": 2010,
        "scenarioValue": 24.417
      },
      {
        "regionId": "6",
        "year": 2020,
        "scenarioValue": 27.259
      },
      {
        "regionId": "6",
        "year": 2030,
        "scenarioValue": 30.4026181818182
      },
      {
        "regionId": "6",
        "year": 2040,
        "scenarioValue": 32.8588
      },
      {
        "regionId": "6",
        "year": 2050,
        "scenarioValue": 35.961
      },
      {
        "regionId": "6",
        "year": 2060,
        "scenarioValue": 39.8010666666666
      },
      {
        "regionId": "6",
        "year": 2070,
        "scenarioValue": 42.9625333333333
      },
      {
        "regionId": "6",
        "year": 2080,
        "scenarioValue": 45.4454
      },
      {
        "regionId": "6",
        "year": 2090,
        "scenarioValue": 52.54155
      },
      {
        "regionId": "6",
        "year": 2100,
        "scenarioValue": 59.6377
      },
      {
        "regionId": "7",
        "year": 2010,
        "scenarioValue": 79.901
      },
      {
        "regionId": "7",
        "year": 2020,
        "scenarioValue": 76.287
      },
      {
        "regionId": "7",
        "year": 2030,
        "scenarioValue": 75.3479090909091
      },
      {
        "regionId": "7",
        "year": 2040,
        "scenarioValue": 74.107
      },
      {
        "regionId": "7",
        "year": 2050,
        "scenarioValue": 71.48
      },
      {
        "regionId": "7",
        "year": 2060,
        "scenarioValue": 87.4806666666667
      },
      {
        "regionId": "7",
        "year": 2070,
        "scenarioValue": 98.1303333333333
      },
      {
        "regionId": "7",
        "year": 2080,
        "scenarioValue": 103.429
      },
      {
        "regionId": "7",
        "year": 2090,
        "scenarioValue": 108.354
      },
      {
        "regionId": "7",
        "year": 2100,
        "scenarioValue": 113.279
      },
      {
        "regionId": "8",
        "year": 2010,
        "scenarioValue": 21.96
      },
      {
        "regionId": "8",
        "year": 2020,
        "scenarioValue": 36.73
      },
      {
        "regionId": "8",
        "year": 2030,
        "scenarioValue": 56.9499090909091
      },
      {
        "regionId": "8",
        "year": 2040,
        "scenarioValue": 71.819
      },
      {
        "regionId": "8",
        "year": 2050,
        "scenarioValue": 76.744
      },
      {
        "regionId": "8",
        "year": 2060,
        "scenarioValue": 83.2306666666667
      },
      {
        "regionId": "8",
        "year": 2070,
        "scenarioValue": 90.4236666666667
      },
      {
        "regionId": "8",
        "year": 2080,
        "scenarioValue": 98.323
      },
      {
        "regionId": "8",
        "year": 2090,
        "scenarioValue": 104.9135
      },
      {
        "regionId": "8",
        "year": 2100,
        "scenarioValue": 111.504
      },
      {
        "regionId": "9",
        "year": 2010,
        "scenarioValue": 21.983
      },
      {
        "regionId": "9",
        "year": 2020,
        "scenarioValue": 19.77
      },
      {
        "regionId": "9",
        "year": 2030,
        "scenarioValue": 19.9084272727273
      },
      {
        "regionId": "9",
        "year": 2040,
        "scenarioValue": 18.7827
      },
      {
        "regionId": "9",
        "year": 2050,
        "scenarioValue": 18.26687
      },
      {
        "regionId": "9",
        "year": 2060,
        "scenarioValue": 18.2147366666667
      },
      {
        "regionId": "9",
        "year": 2070,
        "scenarioValue": 18.1567133333333
      },
      {
        "regionId": "9",
        "year": 2080,
        "scenarioValue": 18.0928
      },
      {
        "regionId": "9",
        "year": 2090,
        "scenarioValue": 18.09125
      },
      {
        "regionId": "9",
        "year": 2100,
        "scenarioValue": 18.0897
      },
      {
        "regionId": "10",
        "year": 2010,
        "scenarioValue": 21.476
      },
      {
        "regionId": "10",
        "year": 2020,
        "scenarioValue": 23.2893
      },
      {
        "regionId": "10",
        "year": 2030,
        "scenarioValue": 23.0023697272727
      },
      {
        "regionId": "10",
        "year": 2040,
        "scenarioValue": 24.196067
      },
      {
        "regionId": "10",
        "year": 2050,
        "scenarioValue": 26.924064
      },
      {
        "regionId": "10",
        "year": 2060,
        "scenarioValue": 29.2030245333333
      },
      {
        "regionId": "10",
        "year": 2070,
        "scenarioValue": 31.2369032
      },
      {
        "regionId": "10",
        "year": 2080,
        "scenarioValue": 33.0257
      },
      {
        "regionId": "10",
        "year": 2090,
        "scenarioValue": 34.496
      },
      {
        "regionId": "10",
        "year": 2100,
        "scenarioValue": 35.9663
      },
      {
        "regionId": "11",
        "year": 2010,
        "scenarioValue": 4.075
      },
      {
        "regionId": "11",
        "year": 2020,
        "scenarioValue": 4.37
      },
      {
        "regionId": "11",
        "year": 2030,
        "scenarioValue": 5.03139936363636
      },
      {
        "regionId": "11",
        "year": 2040,
        "scenarioValue": 5.465393
      },
      {
        "regionId": "11",
        "year": 2050,
        "scenarioValue": 5.9789
      },
      {
        "regionId": "11",
        "year": 2060,
        "scenarioValue": 6.37363333333334
      },
      {
        "regionId": "11",
        "year": 2070,
        "scenarioValue": 6.76163333333333
      },
      {
        "regionId": "11",
        "year": 2080,
        "scenarioValue": 7.1429
      },
      {
        "regionId": "11",
        "year": 2090,
        "scenarioValue": 8.17145
      },
      {
        "regionId": "11",
        "year": 2100,
        "scenarioValue": 9.2
      },
      {
        "regionId": "12",
        "year": 2010,
        "scenarioValue": 27.5966
      },
      {
        "regionId": "12",
        "year": 2020,
        "scenarioValue": 32.855
      },
      {
        "regionId": "12",
        "year": 2030,
        "scenarioValue": 41.1109909090909
      },
      {
        "regionId": "12",
        "year": 2040,
        "scenarioValue": 46.7709
      },
      {
        "regionId": "12",
        "year": 2050,
        "scenarioValue": 51.715
      },
      {
        "regionId": "12",
        "year": 2060,
        "scenarioValue": 56.7983333333333
      },
      {
        "regionId": "12",
        "year": 2070,
        "scenarioValue": 62.004
      },
      {
        "regionId": "12",
        "year": 2080,
        "scenarioValue": 67.332
      },
      {
        "regionId": "12",
        "year": 2090,
        "scenarioValue": 73.0924999999999
      },
      {
        "regionId": "12",
        "year": 2100,
        "scenarioValue": 78.853
      },
      {
        "regionId": "13",
        "year": 2010,
        "scenarioValue": 7.16902
      },
      {
        "regionId": "13",
        "year": 2020,
        "scenarioValue": 8.21848
      },
      {
        "regionId": "13",
        "year": 2030,
        "scenarioValue": 9.82494272727273
      },
      {
        "regionId": "13",
        "year": 2040,
        "scenarioValue": 10.34897
      },
      {
        "regionId": "13",
        "year": 2050,
        "scenarioValue": 10.57359
      },
      {
        "regionId": "13",
        "year": 2060,
        "scenarioValue": 10.7169186666667
      },
      {
        "regionId": "13",
        "year": 2070,
        "scenarioValue": 10.9571586666667
      },
      {
        "regionId": "13",
        "year": 2080,
        "scenarioValue": 11.29431
      },
      {
        "regionId": "13",
        "year": 2090,
        "scenarioValue": 11.532435
      },
      {
        "regionId": "13",
        "year": 2100,
        "scenarioValue": 11.77056
      },
      {
        "regionId": "14",
        "year": 2010,
        "scenarioValue": 22.2407
      },
      {
        "regionId": "14",
        "year": 2020,
        "scenarioValue": 60.1574
      },
      {
        "regionId": "14",
        "year": 2030,
        "scenarioValue": 25.5209454545455
      },
      {
        "regionId": "14",
        "year": 2040,
        "scenarioValue": 25.9364
      },
      {
        "regionId": "14",
        "year": 2050,
        "scenarioValue": 26.8003
      },
      {
        "regionId": "14",
        "year": 2060,
        "scenarioValue": 27.3313
      },
      {
        "regionId": "14",
        "year": 2070,
        "scenarioValue": 27.856889
      },
      {
        "regionId": "14",
        "year": 2080,
        "scenarioValue": 28.377067
      },
      {
        "regionId": "14",
        "year": 2090,
        "scenarioValue": 30.011539
      },
      {
        "regionId": "14",
        "year": 2100,
        "scenarioValue": 31.646011
      },
      {
        "regionId": "15",
        "year": 2010,
        "scenarioValue": 10.34033
      },
      {
        "regionId": "15",
        "year": 2020,
        "scenarioValue": 10.54828
      },
      {
        "regionId": "15",
        "year": 2030,
        "scenarioValue": 10.2790272727273
      },
      {
        "regionId": "15",
        "year": 2040,
        "scenarioValue": 9.9969
      },
      {
        "regionId": "15",
        "year": 2050,
        "scenarioValue": 9.5308
      },
      {
        "regionId": "15",
        "year": 2060,
        "scenarioValue": 9.27489333333334
      },
      {
        "regionId": "15",
        "year": 2070,
        "scenarioValue": 9.03529333333333
      },
      {
        "regionId": "15",
        "year": 2080,
        "scenarioValue": 8.812
      },
      {
        "regionId": "15",
        "year": 2090,
        "scenarioValue": 8.7795
      },
      {
        "regionId": "15",
        "year": 2100,
        "scenarioValue": 8.747
      },
      {
        "regionId": "16",
        "year": 2010,
        "scenarioValue": 102.977
      },
      {
        "regionId": "16",
        "year": 2020,
        "scenarioValue": 101.064
      },
      {
        "regionId": "16",
        "year": 2030,
        "scenarioValue": 97.6386727272727
      },
      {
        "regionId": "16",
        "year": 2040,
        "scenarioValue": 97.5954
      },
      {
        "regionId": "16",
        "year": 2050,
        "scenarioValue": 99.5522
      },
      {
        "regionId": "16",
        "year": 2060,
        "scenarioValue": 112.4252
      },
      {
        "regionId": "16",
        "year": 2070,
        "scenarioValue": 123.7838
      },
      {
        "regionId": "16",
        "year": 2080,
        "scenarioValue": 133.628
      },
      {
        "regionId": "16",
        "year": 2090,
        "scenarioValue": 144.6199
      },
      {
        "regionId": "16",
        "year": 2100,
        "scenarioValue": 155.6118
      }
    ],
    "factor": {
      "id": "12",
      "unit": "EJ",
      "unitShort": "EJ",
      "title": "Primary Energy Consumption"
    }
  }  
}